import {
  faCar,
  faMotorcycle,
  faTruck,
  faBriefcase,
  faHouseChimney,
  faPlaneDeparture,
  faGavel,
  faBuilding,
  faNotesMedical,
  faPills,
  faUserDoctor,
  faUserTie,
  faHeartPulse,
  faBandAid,
  faPeopleRoof,
  faFileLines,
} from '@fortawesome/free-solid-svg-icons';

import generateFiscalCode from '../helpers/generateFiscalCode';

export const genders = [
  {
    value: 'M',
    label: 'Maschio',
  },
  {
    value: 'F',
    label: 'Femmina',
  },
  {
    value: 'G',
    label: 'Persona Giuridica',
  },
];
export const civilStatuses = [
  { id: 1, name: 'Sposato', value: 'sposato' },
  { id: 2, name: 'Single', value: 'single' },
  { id: 3, name: 'Divorziato', value: 'divorziato' },
];
export const professions = [
  { id: 'ragioniere', name: 'Ragioniere', value: 'ragioniere' },
  { id: 'attore', name: 'Attore', value: 'attore' },
  { id: 'attrice', name: 'Attrice', value: 'attrice' },
  {
    id: 'controllore_traffico',
    name: 'Controllore del traffico aereo',
    value: 'controllore_traffico',
  },
  { id: 'architetto', name: 'Architetto', value: 'architetto' },
  { id: 'artista', name: 'Artista', value: 'artista' },
  { id: 'avvocato', name: 'Avvocato', value: 'avvocato' },
  { id: 'contabile', name: 'Contabile', value: 'contabile' },
  { id: 'barbiere', name: 'Barbiere', value: 'barbiere' },
  { id: 'barista', name: 'Barista', value: 'barista' },
  { id: 'banker', name: 'banker', value: 'banker' },
  { id: 'costruttore', name: 'costruttore', value: 'costruttore' },
  { id: ',acellaio', name: 'Macellaio', value: 'macellaio' },
  { id: 'falegname', name: 'Falegname', value: 'falegname' },
  { id: 'cassiere', name: 'Cassiere', value: 'cassiere' },
  { id: 'chef', name: 'Chef', value: 'chef' },
  { id: 'coach', name: 'Coach', value: 'coach' },
  { id: 'dentista', name: 'Dentista', value: 'dentista' },
  { id: 'progettista', name: 'Progettista', value: 'progettista' },
  { id: 'sviluppatore', name: 'Sviluppatore', value: 'sviluppatore' },
  { id: 'dietologo', name: 'Dietologo', value: 'dietologo' },
  { id: 'dottore', name: 'Dottore', value: 'dottore' },
  { id: 'economista', name: 'Economista', value: 'economista' },
  { id: 'direttore', name: 'Direttore', value: 'direttore' },
  { id: 'elettricista', name: 'Elettricista', value: 'elettricista' },
  { id: 'ingegnere', name: 'Ingegnere', value: 'ingegnere' },
];
export const flagResponse = [
  { label: 'Sì', value: 1 },
  { label: 'No', value: 0 },
];

export const months = [
  { id: '01', name: 'Gennaio', value: 'gennaio' },
  { id: '02', name: 'Febbraio', value: 'febbraio' },
  { id: '03', name: 'Marzo', value: 'marzo' },
  { id: '04', name: 'Aprile', value: 'aprile' },
  { id: '05', name: 'Maggio', value: 'maggio' },
  { id: '06', name: 'Giugno', value: 'giugno' },
  { id: '07', name: 'Luglio', value: 'luglio' },
  { id: '08', name: 'Agosto', value: 'agosto' },
  { id: '09', name: 'Settembre', value: 'settembre' },
  { id: '10', name: 'Ottobre', value: 'ottobre' },
  { id: '11', name: 'Novembre', value: 'novembre' },
  { id: '12', name: 'Dicembre', value: 'dicembre' },
];
export const power_supply = [
  { id: 'nesuna', name: 'Nesuna', value: 'nesuna' },
  { id: 'methane', name: 'Methane', value: 'methane' },
  { id: 'benzina', name: 'Benzina', value: 'benzina' },
];

export const insuranceTypes = [
  { id: 'N', name: 'Nuova polizza', value: '' },
  { id: 'B', name: 'Rinnovo', value: '' },
];

// (Tempo libero, casa lavoro, lavoro
export const usage_types = [
  { id: 'tempo-libero', name: 'Tempo libero', value: 'tempo-libero' },
  { id: 'casa-lavoro', name: 'Casa lavoro', value: 'casa-lavoro' },
  { id: 'lavoro', name: 'Lavoro', value: 'lavoro' },
];

export const km_during_one_year = [
  { id: 10000, name: '10000', value: '10000' },
  { id: 20000, name: '20000', value: '20000' },
  { id: 30000, name: '30000', value: '30000' },
  { id: 50000, name: '50000', value: '50000' },
];

export const vehiclesAmountInFamily = [
  { id: 1, name: '1', value: '1' },
  { id: 2, name: '2', value: '2' },
  { id: 3, name: '3', value: '3' },
  { id: 4, name: '4', value: '4' },
  { id: 5, name: '4+', value: '4+' },
];

export const meritClass = [
  { id: 1, name: '1', value: '1' },
  { id: 2, name: '2', value: '2' },
  { id: 3, name: '3', value: '3' },
  { id: 4, name: '4', value: '4' },
  { id: 5, name: '5', value: '5' },
  { id: 6, name: '6', value: '6' },
  { id: 7, name: '7', value: '7' },
  { id: 8, name: '8', value: '8' },
  { id: 9, name: '9', value: '9' },
  { id: 10, name: '10', value: '10' },
  { id: 11, name: '11', value: '11' },
  { id: 12, name: '12', value: '12' },
  { id: 13, name: '13', value: '13' },
  { id: 14, name: '14', value: '14' },
  { id: 15, name: '15', value: '15' },
  { id: 16, name: '16', value: '16' },
  { id: 17, name: '17', value: '17' },
  { id: 18, name: '18', value: '18' },
];

export const inheritMeritClass = [
  { id: 'N', name: 'No', value: 'N' },
  { id: 'S', name: 'Si: è mio', value: 'S' },
  { id: 'A', name: 'Si: è di un mio familiare convivente', value: 'A' },
];

export const guideType = [
  { id: 'free', name: 'Guida libera' },
  { id: 'expert', name: 'Guida esperta' },
  { id: 'exclusive', name: 'Guida esclusiva' },
];

export const years = (() => {
  const y = [];
  const maxYear = new Date().getFullYear();
  const minYear = 1990;
  for (let i = maxYear; i >= minYear; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y;
})();

export const lastSixYears = (() => {
  const y = [];
  const maxYear = new Date().getFullYear();
  const minYear = maxYear - 6;
  for (let i = maxYear; i > minYear; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y;
})();

export const lastfifteenYears = (() => {
  const y = [];
  const maxYear = new Date().getFullYear();
  const minYear = maxYear - 15;
  for (let i = maxYear; i > minYear; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y;
})();

export const getLastSixYearsBySelectedYear = (year) => {
  const y = [];
  const cY = new Date().getFullYear();
  const diff = cY - year;

  const max = diff > 4 ? cY - 1 : cY;
  const min = max - 5;
  for (let i = max; i >= min; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y;
};

export const engineerCodes = ['ingegnere', 'architetto', 'geometra'];

export const allowedProfessionCompanyIds = ['94'];

export const violationTypes = [
  { id: 'principale', name: "Pagato con responsabilita' principale" },
  { id: 'paritaria', name: "Pagato con responsabilita' paritaria" },
];

export const metlifeMenoMaleGold = {
  piano: [
    {
      id: 'nucleo',
      label: 'Nucleo',
    },
    {
      id: 'individuo',
      label: 'Individuo',
    },
  ],
  massimale: [
    {
      id: '50000',
      label: '50000',
    },
    {
      id: '100000',
      label: '100000',
    },
    {
      id: '150000',
      label: '150000',
    },
    {
      id: '200000',
      label: '200000',
    },
  ],
  estensioni: [
    {
      id: 'ustioni',
      label: 'Ustioni / Lussazioni / Commazioni',
    },
    {
      id: 'rimborso',
      label: 'Rimborso Spese Mediche',
    },
  ],
};

export const invoiceTypes = [
  {
    id: '23_to_50',
    name: '23% su 50%',
    value: '23_to_50',
  },
  {
    id: '23_to_20',
    name: '23% su 20%',
    value: '23_to_20',
  },
];

export const vehicleTypes = [
  {
    id: 'car',
    name: 'Auto',
  },
  {
    id: 'van',
    name: 'Autocarro',
  },
  {
    id: 'motorcycle',
    name: 'Moto',
  },
];

export const productsTravel = {
  EA0125: 'Travel Protection Top',
  EA0180: 'Viaggi Studi Stage',
  EA0177: 'Viaggi Europa',
  EA0190: 'Viaggi Mondo',
  EA0162: 'Viaggi Annuale',
  EA0157: 'Viaggi Nostop Vacanza Multiviaggio',
};

export const companies = [
  {
    id: '1',
    name: 'Adriatic',
    value: 'adriatic',
  },
  {
    id: '2',
    name: 'Prima.it',
    value: 'prima.it',
  },
  {
    id: '3',
    name: 'Quixa',
    value: 'quixa',
  },
  {
    id: '4',
    name: 'Tokio Marine HCC',
    value: 'tokio Marine HCC',
  },
  {
    id: '5',
    name: 'MetLife',
    value: 'metLife',
  },
  {
    id: '7',
    name: 'Conte.It Assicurazioni',
    value: 'conte.It Assicurazioni',
  },
  {
    id: '8',
    name: 'Redion',
    value: 'Redion',
  },
];

export const companyNamesById = [
  {
    id: '1',
    name: 'Adriatic',
  },
  {
    id: '2',
    name: 'Prima.it',
  },
  {
    id: '3',
    name: 'Quixa',
  },
  {
    id: '4',
    name: 'Tokio Marine HCC',
  },
  {
    id: '5',
    name: 'MetLife',
  },
  {
    id: '6',
    name: 'InfoDrive',
  },
  {
    id: '7',
    name: 'Conte.It Assicurazioni',
  },
  {
    id: '8',
    name: 'Redion',
  },
  {
    id: '9',
    name: 'Linear',
  },
  {
    id: '10',
    name: 'Dallbog',
  },
  {
    id: '11',
    name: 'Greenia',
  },
  {
    id: '12',
    name: 'Greenia 1',
  },
  {
    id: '13',
    name: 'Greenia 2',
  },
  {
    id: '14',
    name: 'Greenia 3',
  },
  {
    id: '15',
    name: 'Arag',
  },
  {
    id: '16',
    name: 'Global Assistance',
  },
  {
    id: '17',
    name: 'Euroherc Assicurazioni',
  },
  {
    id: '18',
    name: 'Genial Piu',
  },
  {
    id: '19',
    name: 'AmTrust Assicurazioni',
  },
  {
    id: '1000',
    name: 'Verti Professionals',
  },
  {
    id: '1001',
    name: 'Nobis Assicurazioni',
  },
  {
    id: '1002',
    name: 'WeBind',
  },
];

export const legal_forms = [
  {
    id: 'srl',
    name: 'Srl',
    value: 'srl',
  },
  {
    id: 'spa',
    name: 'Spa',
    value: 'spa',
  },
  {
    id: 'snc',
    name: 'Snc',
    value: 'snc',
  },
  {
    id: 'sas',
    name: 'Sas',
    value: 'sas',
  },
  {
    id: 'ditta_individuale',
    name: 'Ditta Individuale',
    value: 'ditta_individuale',
  },
  {
    id: 'fondazione',
    name: 'Fondazione',
    value: 'fondazione',
  },
  {
    id: 'societa_cooperativa',
    name: 'Società Cooperativa',
    value: 'societa_cooperativa',
  },
];

export const coverage_types = [
  {
    id: '1',
    name: 'Basico',
    value: 'Basico',
  },
  {
    id: '2',
    name: 'Premium',
    value: 'Premium',
  },
];

export const civil_liability_types = [
  {
    id: '500000',
    name: '500K',
    value: '500K',
  },
  {
    id: '1000000',
    name: '1M',
    value: '1M',
  },
  {
    id: '1500000',
    name: '1.5M',
    value: '1.5M',
  },
];

export const widgetsConstatns = [
  {
    id: 1,
    name: 'Cerca Cliente',
  },
  {
    id: 2,
    name: 'Report',
  },
  {
    id: 3,
    name: 'Ultimi Aggiornamenti',
  },
  {
    id: 4,
    name: 'Agenda',
  },
  {
    id: 5,
    name: 'Ultimi Articoli',
  },
  {
    id: 6,
    name: 'Fai Un Preventivo',
  },
  {
    id: 7,
    name: 'Analisi Rui',
  },
  // {
  //   id: 8,
  //   name: 'Supporto Chat Vocale AI',
  // },
  // {
  //   id: 9,
  //   name: 'Supporto Chat AI',
  // },
];

export const productsList = [
  {
    id: 1,
    name: 'Auto',
  },
  {
    id: 2,
    name: 'Moto',
  },
  {
    id: 3,
    name: 'Autocarro',
  },
  {
    id: 4,
    name: 'Professionale',
  },
  {
    id: 5,
    name: 'Infortuni',
  },
  {
    id: 8,
    name: 'Viaggi',
  },
  {
    id: 9,
    name: 'Tutela Legale',
  },
  { id: 10, name: 'Commercial' },
  { id: 11, name: 'Casa' },
  { id: 12, name: 'Salute' },
  { id: 13, name: 'Ancillari Auto' },
  { id: 15, name: 'Professioni Sanitarie' },
  { id: 1003, name: 'Condominio' },

];

export const provenienza = [
  {
    id: 1,
    name: 'Attestato',
  },
  {
    id: 2,
    name: 'Voltura',
  },
  {
    id: 3,
    name: 'Prima Immatricolazione',
  },
];

export const adr = [
  {
    id: 1,
    name: 'No',
  },
  {
    id: 2,
    name: 'Infiammabili',
  },
  {
    id: 3,
    name: 'Merci Esplosive/Radioattive (ADR 1,7,9)',
  },
];

export const usoAutocarro = [
  {
    id: 1,
    name: 'Conto Terzi',
  },
  {
    id: 2,
    name: 'Conto Propio',
  },
];

export const creditRatingCommonValue = [
  {
    id: 'A',
    name: 'A',
  },
  {
    id: 'B',
    name: 'B',
  },
  {
    id: 'C',
    name: 'C',
  },
  {
    id: 'D',
    name: 'D',
  },
  {
    id: 'E',
    name: 'E',
  },
];

export const positiveOrNegative = [
  {
    id: 'Positive',
    name: 'Positive',
  },
  {
    id: 'Negative',
    name: 'Negative',
  },
  {
    id: 'Neutral',
    name: 'Neutral',
  },
];

export const shareholderType = [
  {
    id: 'Person',
    name: 'Person',
  },
  {
    id: 'Company',
    name: 'Company',
  },
  {
    id: 'Other',
    name: 'Other',
  },
];

export const commercialCountry = [{
  id: 'AF',
  name: 'AF',
},
{
  id: 'AX',
  name: 'AX',
},
{
  id: 'AL',
  name: 'AL',
}, {
  id: 'DZ',
  name: 'DZ',
}, {
  id: 'AS',
  name: 'AS',
}, {
  id: 'AD',
  name: 'AD',
}, {
  id: 'AO',
  name: 'AO',
}, {
  id: 'AI',
  name: 'AI',
}, {
  id: 'AQ',
  name: 'AQ',
}, {
  id: 'AG',
  name: 'AG',
}, {
  id: 'AR',
  name: 'AR',
}, {
  id: 'AM',
  name: 'AM',
}, {
  id: 'AW',
  name: 'AW',
}, {
  id: 'AU',
  name: 'AU',
}, {
  id: 'AT',
  name: 'AT',
}, {
  id: 'AZ',
  name: 'AZ',
}, {
  id: 'BS',
  name: 'BS',
}, {
  id: 'BH',
  name: 'BH',
}, {
  id: 'BD',
  name: 'BD',
}, {
  id: 'BB',
  name: 'BB',
}, {
  id: 'BY',
  name: 'BY',
}, {
  id: 'BE',
  name: 'BE',
}, {
  id: 'BZ',
  name: 'BZ',
}, {
  id: 'BJ',
  name: 'BJ',
}, {
  id: 'BM',
  name: 'BM',
}, {
  id: 'BT',
  name: 'BT',
}, {
  id: 'BO',
  name: 'BO',
}, {
  id: 'BA',
  name: 'BA',
}, {
  id: 'BW',
  name: 'BW',
}, {
  id: 'BV',
  name: 'BV',
}, {
  id: 'BR',
  name: 'BR',
}, {
  id: 'IO',
  name: 'IO',
}, {
  id: 'BN',
  name: 'BN',
}, {
  id: 'BG',
  name: 'BG',
}, {
  id: 'BF',
  name: 'BF',
}, {
  id: 'BI',
  name: 'BI',
}, {
  id: 'KH',
  name: 'KH',
}, {
  id: 'CM',
  name: 'CM',
}, {
  id: 'CA',
  name: 'CA',
}, {
  id: 'CV',
  name: 'CV',
}, {
  id: 'KY',
  name: 'KY',
}, {
  id: 'CF',
  name: 'CF',
}, {
  id: 'TD',
  name: 'TD',
}, {
  id: 'CL',
  name: 'CL',
}, {
  id: 'CN',
  name: 'CN',
}, {
  id: 'CX',
  name: 'CX',
}, {
  id: 'CC',
  name: 'CC',
}, {
  id: 'CO',
  name: 'CO',
}, {
  id: 'KM',
  name: 'KM',
}, {
  id: 'CG',
  name: 'CG',
}, {
  id: 'CD',
  name: 'CD',
}, {
  id: 'CK',
  name: 'CK',
}, {
  id: 'CR',
  name: 'CR',
}, {
  id: 'CI',
  name: 'CI',
}, {
  id: 'HR',
  name: 'HR',
}, {
  id: 'CU',
  name: 'CU',
}, {
  id: 'CY',
  name: 'CY',
}, {
  id: 'CZ',
  name: 'CZ',
}, {
  id: 'DK',
  name: 'DK',
}, {
  id: 'DJ',
  name: 'DJ',
}, {
  id: 'DM',
  name: 'DM',
}, {
  id: 'DO',
  name: 'DO',
}, {
  id: 'EC',
  name: 'EC',
}, {
  id: 'EG',
  name: 'EG',
}, {
  id: 'SV',
  name: 'SV',
}, {
  id: 'GQ',
  name: 'GQ',
}, {
  id: 'ER',
  name: 'ER',
}, {
  id: 'EE',
  name: 'EE',
}, {
  id: 'ET',
  name: 'ET',
}, {
  id: 'FK',
  name: 'FK',
}, {
  id: 'FO',
  name: 'FO',
}, {
  id: 'FJ',
  name: 'FJ',
}, {
  id: 'FI',
  name: 'FI',
}, {
  id: 'FR',
  name: 'FR',
}, {
  id: 'GF',
  name: 'GF',
}, {
  id: 'PF',
  name: 'PF',
}, {
  id: 'TF',
  name: 'TF',
}, {
  id: 'GA',
  name: 'GA',
}, {
  id: 'GM',
  name: 'GM',
}, {
  id: 'GE',
  name: 'GE',
}, {
  id: 'DE',
  name: 'DE',
}, {
  id: 'GH',
  name: 'GH',
}, {
  id: 'GI',
  name: 'GI',
}, {
  id: 'GR',
  name: 'GR',
}, {
  id: 'GL',
  name: 'GL',
}, {
  id: 'GD',
  name: 'GD',
}, {
  id: 'GP',
  name: 'GP',
}, {
  id: 'GU',
  name: 'GU',
}, {
  id: 'GT',
  name: 'GT',
}, {
  id: 'GG',
  name: 'GG',
}, {
  id: 'GN',
  name: 'GN',
}, {
  id: 'GW',
  name: 'GW',
}, {
  id: 'GY',
  name: 'GY',
}, {
  id: 'HT',
  name: 'HT',
}, {
  id: 'HM',
  name: 'HM',
}, {
  id: 'HN',
  name: 'HN',
}, {
  id: 'HK',
  name: 'HK',
}, {
  id: 'HU',
  name: 'HU',
}, {
  id: 'IS',
  name: 'IS',
}, {
  id: 'IN',
  name: 'IN',
}, {
  id: 'ID',
  name: 'ID',
}, {
  id: 'IR',
  name: 'IR',
}, {
  id: 'IQ',
  name: 'IQ',
}, {
  id: 'IE',
  name: 'IE',
}, {
  id: 'IM',
  name: 'IM',
}, {
  id: 'IL',
  name: 'IL',
}, {
  id: 'IT',
  name: 'IT',
}, {
  id: 'JM',
  name: 'JM',
}, {
  id: 'JP',
  name: 'JP',
}, {
  id: 'JE',
  name: 'JE',
}, {
  id: 'JO',
  name: 'JO',
}, {
  id: 'KZ',
  name: 'KZ',
}, {
  id: 'KE',
  name: 'KE',
}, {
  id: 'KI',
  name: 'KI',
}, {
  id: 'KP',
  name: 'KP',
}, {
  id: 'KR',
  name: 'KR',
}, {
  id: 'KW',
  name: 'KW',
}, {
  id: 'KG',
  name: 'KG',
}, {
  id: 'LA',
  name: 'LA',
}, {
  id: 'LV',
  name: 'LV',
}, {
  id: 'LB',
  name: 'LB',
}, {
  id: 'LS',
  name: 'LS',
}, {
  id: 'LR',
  name: 'LR',
}, {
  id: 'LY',
  name: 'LY',
}, {
  id: 'LI',
  name: 'LI',
}, {
  id: 'LT',
  name: 'LT',
}, {
  id: 'LU',
  name: 'LU',
}, {
  id: 'MO',
  name: 'MO',
}, {
  id: 'MK',
  name: 'MK',
}, {
  id: 'MG',
  name: 'MG',
}, {
  id: 'MW',
  name: 'MW',
}, {
  id: 'MY',
  name: 'MY',
}, {
  id: 'MV',
  name: 'MV',
}, {
  id: 'ML',
  name: 'ML',
}, {
  id: 'MT',
  name: 'MT',
}, {
  id: 'MH',
  name: 'MH',
}, {
  id: 'MQ',
  name: 'MQ',
}, {
  id: 'MR',
  name: 'MR',
}, {
  id: 'MU',
  name: 'MU',
}, {
  id: 'YT',
  name: 'YT',
}, {
  id: 'MX',
  name: 'MX',
}, {
  id: 'FM',
  name: 'FM',
}, {
  id: 'MD',
  name: 'MD',
}, {
  id: 'MC',
  name: 'MC',
}, {
  id: 'MN',
  name: 'MN',
}, {
  id: 'ME',
  name: 'ME',
}, {
  id: 'MS',
  name: 'MS',
}, {
  id: 'MA',
  name: 'MA',
}, {
  id: 'MZ',
  name: 'MZ',
}, {
  id: 'MM',
  name: 'MM',
}, {
  id: 'NA',
  name: 'NA',
}, {
  id: 'NR',
  name: 'NR',
}, {
  id: 'NP',
  name: 'NP',
}, {
  id: 'NL',
  name: 'NL',
}, {
  id: 'AN',
  name: 'AN',
}, {
  id: 'NC',
  name: 'NC',
}, {
  id: 'NZ',
  name: 'NZ',
}, {
  id: 'NI',
  name: 'NI',
}, {
  id: 'NE',
  name: 'NE',
}, {
  id: 'NG',
  name: 'NG',
}, {
  id: 'NU',
  name: 'NU',
}, {
  id: 'NF',
  name: 'NF',
}, {
  id: 'MP',
  name: 'MP',
}, {
  id: 'NO',
  name: 'NO',
}, {
  id: 'OM',
  name: 'OM',
}, {
  id: 'PK',
  name: 'PK',
}, {
  id: 'PW',
  name: 'PW',
}, {
  id: 'PS',
  name: 'PS',
}, {
  id: 'PA',
  name: 'PA',
}, {
  id: 'PG',
  name: 'PG',
}, {
  id: 'PY',
  name: 'PY',
}, {
  id: 'PE',
  name: 'PE',
}, {
  id: 'PH',
  name: 'PH',
}, {
  id: 'PN',
  name: 'PN',
}, {
  id: 'PL',
  name: 'PL',
}, {
  id: 'PT',
  name: 'PT',
}, {
  id: 'PR',
  name: 'PR',
}, {
  id: 'QA',
  name: 'QA',
}, {
  id: 'RE',
  name: 'RE',
}, {
  id: 'RO',
  name: 'RO',
}, {
  id: 'RU',
  name: 'RU',
}, {
  id: 'RW',
  name: 'RW',
}, {
  id: 'BL',
  name: 'BL',
}, {
  id: 'SH',
  name: 'SH',
}, {
  id: 'KN',
  name: 'KN',
}, {
  id: 'LC',
  name: 'LC',
}, {
  id: 'MF',
  name: 'MF',
}, {
  id: 'PM',
  name: 'PM',
}, {
  id: 'VC',
  name: 'VC',
}, {
  id: 'WS',
  name: 'WS',
}, {
  id: 'SM',
  name: 'SM',
}, {
  id: 'ST',
  name: 'ST',
}, {
  id: 'SA',
  name: 'SA',
}, {
  id: 'SN',
  name: 'SN',
}, {
  id: 'RS',
  name: 'RS',
}, {
  id: 'SC',
  name: 'SC',
}, {
  id: 'SL',
  name: 'SL',
}, {
  id: 'SG',
  name: 'SG',
}, {
  id: 'SK',
  name: 'SK',
}, {
  id: 'SI',
  name: 'SI',
}, {
  id: 'SB',
  name: 'SB',
}, {
  id: 'SO',
  name: 'SO',
}, {
  id: 'ZA',
  name: 'ZA',
}, {
  id: 'GS',
  name: 'GS',
}, {
  id: 'ES',
  name: 'ES',
}, {
  id: 'LK',
  name: 'LK',
}, {
  id: 'SD',
  name: 'SD',
}, {
  id: 'SR',
  name: 'SR',
}, {
  id: 'SJ',
  name: 'SJ',
}, {
  id: 'SZ',
  name: 'SZ',
}, {
  id: 'SE',
  name: 'SE',
}, {
  id: 'CH',
  name: 'CH',
}, {
  id: 'SY',
  name: 'SY',
}, {
  id: 'TW',
  name: 'TW',
}, {
  id: 'TJ',
  name: 'TJ',
}, {
  id: 'TZ',
  name: 'TZ',
}, {
  id: 'TH',
  name: 'TH',
}, {
  id: 'TL',
  name: 'TL',
}, {
  id: 'TG',
  name: 'TG',
}, {
  id: 'TK',
  name: 'TK',
}, {
  id: 'TO',
  name: 'TO',
}, {
  id: 'TT',
  name: 'TT',
}, {
  id: 'TN',
  name: 'TN',
}, {
  id: 'TR',
  name: 'TR',
}, {
  id: 'TM',
  name: 'TM',
}, {
  id: 'TC',
  name: 'TC',
}, {
  id: 'TV',
  name: 'TV',
}, {
  id: 'UG',
  name: 'UG',
}, {
  id: 'UA',
  name: 'UA',
}, {
  id: 'AE',
  name: 'AE',
}, {
  id: 'GB',
  name: 'GB',
}, {
  id: 'US',
  name: 'US',
}, {
  id: 'UM',
  name: 'UM',
}, {
  id: 'UY',
  name: 'UY',
}, {
  id: 'UZ',
  name: 'UZ',
}, {
  id: 'VU',
  name: 'VU',
}, {
  id: 'VA',
  name: 'VA',
}, {
  id: 'VE',
  name: 'VE',
}, {
  id: 'VN',
  name: 'VN',
}, {
  id: 'VG',
  name: 'VG',
}, {
  id: 'VI',
  name: 'VI',
}, {
  id: 'WF',
  name: 'WF',
}, {
  id: 'EH',
  name: 'EH',
}, {
  id: 'YE',
  name: 'YE',
}, {
  id: 'ZM',
  name: 'ZM',
}, {
  id: 'ZW',
  name: 'ZW',
}, {
  id: 'XK',
  name: 'XK',
}, {
  id: 'SS',
  name: 'SS',
}, {
  id: 'SX',
  name: 'SX',
}, {
  id: 'CW',
  name: 'CW',
}, {
  id: 'BQ',
  name: 'BQ',
}, {
  id: 'WW',
  name: 'WW',
}, {
  id: 'PLC',
  name: 'PLC',
}];

export const questionInCommercial = [
  {
    id: 'sistema_a_muri_portanti',
    name: 'Sistema a muri portanti',
  },
  {
    id: 'sistema_a_telaio_travi_pilastri',
    name: 'Sistema a telaio (travi + pilastri)',
  },
  {
    id: 'sistema_misto_muri_portanti_travi_pilastri',
    name: 'Sistema misto (muri portanti + travi + pilastri)',
  },
];

export const questionInProcessiProdotti = [
  {
    id: 'basso',
    name: 'Basso',
  },
  {
    id: 'medio',
    name: 'Medio',
  },
  {
    id: 'alto',
    name: 'Alto',
  },
];

export const commercialTypes = ['rct_cose_quote',
  'rct_veicoli_quote',
  'rct_postuma_autofficine_quote',
  'rct_postuma_12_quote',
  'rct_postuma_dm_quote',
  'rct_furto_quote',
  'rco_quote',
  'rc_prodotto_quote',
  'do_quote',
  'rct_rc_impresa_edile',
  'rc_personale_soggeti_dipendenti_servizio_struttura',
  'danni_veicoli_prestatori_fornitori_parcheggiati_impresa',
  'commitenza_di_lavori_straordinaria_manutenzione',
  'attivita_intrattenimento_arte_varia',
  'danni_causato_animali_agriturismo',
  'organizzazione_gite_ed_escursioni',
  'estensione_tipo_ristorante_sportiva_ecc',
  'estensione_passeggiate_cavallo',
  'estensione_veicoli_dei_clienti',
  'commercial_land',
  'contenuto_systems_machines',
  'contenuto_industrial_commercial_machines',
  'refrigeration_goods',
  'rental_risk',
  'third_party_recourse',
  'other_property_damage_bucket_rate',
  'fire_bucket_rate',
  'earthquake',
  'earthquake_and_flood',
  'content_theft',
  'business_electronics',
  'business_assistance',
];

export const commercialExtraQuoteTypes = [
  {
    id: 'extra_incendio_fabbricato',
    name: 'Incendio Fabbricato',
  },
  {
    id: 'extra_incendio_contenuto',
    name: 'Incendio Contenuto',
  },
  {
    id: 'extra_ricorso_terzi_incendio',
    name: 'Ricorso Terzi Da Incendio',
  },
  {
    id: 'extra_danni_aqua',
    name: 'Danni D’Acqua',
  },
  {
    id: 'extra_fenomeno_elettrico',
    name: 'Fenomeno Elettrico',
  },
  {
    id: 'extra_eventi_atmosferici',
    name: 'Eventi Atmosferici',
  },
  {
    id: 'extra_eventi_sociopolitici',
    name: 'Eventi Sociopolitici',
  },
  {
    id: 'extra_atti_terrorismo',
    name: 'Atti Di Terrorismo',
  },
  {
    id: 'extra_allagamento',
    name: 'Allagamento',
  },
  {
    id: 'extra_rottura_lastre',
    name: 'Rottura Lastre',
  },
  {
    id: 'extra_guasti_macchine',
    name: 'Guasti Macchine',
  },
  {
    id: 'extra_merci_refrigerazione',
    name: 'Merci In Refrigerazione',
  },
  {
    id: 'extra_rcf',
    name: 'RCF',
  },
  {
    id: 'extra_rci',
    name: 'RCI',
  },
  {
    id: 'extra_furto_rapina_estorsione',
    name: 'Furto, Rapina Ed Estorsione',
  },
  {
    id: 'extra_furto_valori_preziosi_cassaforte',
    name: 'Furto Valori E Preziosi In Cassaforte',
  },
  {
    id: 'extra_portavalori',
    name: 'Portavalori',
  },
  {
    id: 'extra_assistenza_fabbricato',
    name: 'Assistenza Al Fabbricato',
  },
  {
    id: 'extra_business_interruption',
    name: 'Business Interruption',
  },
  {
    id: 'extra_apparecchiature_elettroniche',
    name: 'Apparecchiature Elettroniche',
  },
  {
    id: 'extra_maggiori_costi',
    name: 'Maggiori Costi',
  },
  {
    id: 'extra_programmi_licenza_uso',
    name: "Programmi In Licenza D'Uso",
  },
  {
    id: 'extra_supporto_dati',
    name: 'Supporto Dati',
  },
];

export const quotationTypes = [
  {
    id: 'res_civile',
    name: 'Responsabilita Civile',
  },
  {
    id: 'tutela_legale',
    name: 'Tutela Legale',
  },
  {
    id: 'assistenza_stradale',
    name: 'Assistenza Stradale',
  },
  {
    id: 'infortuni_conducente',
    name: 'Infortuni Conducente',
  },
  {
    id: 'rc_transportati_minori',
    name: 'RC Trasportati e minori',
  },
  {
    id: 'cristalli',
    name: 'Cristalli',
  },
  {
    id: 'rivalsa',
    name: 'Rivalsa',
  },
  {
    id: 'rct_cose_quote',
    name: 'RCT - Danni Alle Cose Su Cui Si Eseguono Lavori',
  },
  {
    id: 'rct_veicoli_quote',
    name: 'RCT - Danni Ai Veicoli In Consegna e Custodia',
  },
  {
    id: 'rct_postuma_autofficine_quote',
    name: 'RCT - RC Postuma Autofficine',
  },
  {
    id: 'rct_postuma_12_quote',
    name: 'RCT - RC Postuma 12 Mesi',
  },
  {
    id: 'rct_postuma_dm_quote',
    name: 'RCT - RC Postuma D.M.37/2008',
  },
  {
    id: 'rct_furto_quote',
    name: 'RCT - Danni Da Furto',
  },
  {
    id: 'rco_quote',
    name: 'RCO',
  },
  {
    id: 'rc_prodotto_quote',
    name: 'RC Prodotto',
  },
  {
    id: 'do_quote',
    name: 'D&O',
  },
  {
    id: 'rct_rc_impresa_edile',
    name: 'RCT - RC IMPRESA EDILE',
  },
  {
    id: 'rc_personale_soggeti_dipendenti_servizio_struttura',
    name: 'R.C. PERSONALE DEI SOGGETTI NON DIPENDENTI AL SERVIZIO DELLA STRUTTURA',
  },
  {
    id: 'danni_veicoli_prestatori_fornitori_parcheggiati_impresa',
    name: 'DANNI A VEICOLI DEI PRESTATORI DI LAVORO E FORNITORI PARCHEGGIATI NEGLI SPAZI DI PERTINENZA DELL’IMPRESA ASSICURATA',
  },
  {
    id: 'commitenza_di_lavori_straordinaria_manutenzione',
    name: 'COMMITTENZA DI LAVORI DI STRAORDINARIA MANUTENZIONE',
  },
  {
    id: 'attivita_intrattenimento_arte_varia',
    name: 'ATTIVITÀ DI INTRATTENIMENTO E ARTE VARIA',
  },
  {
    id: 'danni_causato_animali_agriturismo',
    name: 'DANNI CAUSATI DAGLI ANIMALI - ATTIVITÀ DI AGRITURISMO',
  },
  {
    id: 'organizzazione_gite_ed_escursioni',
    name: 'ORGANIZZAZIONE DI GITE ED ESCURSIONI',
  },
  {
    id: 'estensione_tipo_ristorante_sportiva_ecc',
    name: 'ESTENSIONE TIPOLOGIA ATTIVITÀ (RISTORAZIONE, SPORTIVA, STABILIMENTI TERMALI, SPA ECC.)',
  },
  {
    id: 'estensione_passeggiate_cavallo',
    name: 'ESTENSIONE PASSEGGIATE A CAVALLO - DANNI AI CAVALIERI',
  },
  {
    id: 'estensione_veicoli_dei_clienti',
    name: 'ESTENSIONE VEICOLI DEI CLIENTI',
  },
  // { id: 'kasko', name: 'Kasko completa' },
  { id: 'collisione', name: 'Collisione Animali Selvatici' },
  { id: 'eventi_socio_politici', name: 'Eventi Socio Politici' },
  { id: 'eventi_naturali', name: 'Eventi naturali' },
  // { id: 'bonus_protetto', name: 'Bonus protetto' },
  { id: 'furto_incendio', name: 'Furto e incendio' },
  {
    id: 'incendio_fabbricato',
    name: 'Incendio e scoppio fabbricato',
  },
  {
    id: 'incendio_contentuto',
    name: 'Incendio e scoppio contenuto',
  },
  {
    id: 'danni_elettrici_contenuto',
    name: 'Danni elettrici al contenuto',
  },
  {
    id: 'spese_legali_propietario_immobiliare',
    name: 'Spese legali proprietario immobiliare',
  },
  {
    id: 'danni_terzi_famiglia',
    name: 'Danni a terzi famiglia e conduzione',
  },
  {
    id: 'danni_terzi_propietario',
    name: 'Danni a terzi proprietario',
  },
  {
    id: 'spese_legali_famiglia',
    name: 'Spese legali famiglia',
  },
  {
    id: 'furto_casa',
    name: 'Furto',
  },
  {
    id: 'inagibilita_abitazione',
    name: 'Inagibilità abitazione',
  },
  {
    id: 'inagibilita',
    name: 'Inagibilità',
  },
  {
    id: 'danni_elettrici_al_fabricato',
    name: 'Danni elettrici al fabbricato',
  },
  {
    id: 'fuori_uscita_di_acqua_gas',
    name: 'Fuoriuscita di acqua e gas',
  },
  {
    id: 'assistenza_malattia',
    name: 'Assistenza Malattia',
  },
  {
    id: 'adattamento_abitazione_malattia',
    name: 'Adattamento Abitazione Malattia',
  },
  {
    id: 'rsm_grave_malattia',
    name: 'RSM Grave Malattia',
  },
  {
    id: 'indennita_sostitutiva_malattia',
    name: 'Indennita Sostitutiva Malattia',
  },
  {
    id: 'daria_da_convalescenza_malattia',
    name: 'Daria da Convalescenza Post Terapia Intensiva Malattia',
  },
  {
    id: 'indennitaria_da_malattia',
    name: 'Indennitaria da Malattia',
  },
  {
    id: 'rsm_post_ricovero_malattia',
    name: 'RSM Post Ricovero Malattia',
  },
  {
    id: 'assistenza_post_infortunio',
    name: 'Assistenza Post Infortunio',
  },
  {
    id: 'adattamento_abitazione_veicolo_infortunio',
    name: 'Adattamento Abitazione+Veicolo Infortunio',
  },
  {
    id: 'indennizzo_da_infortunio',
    name: 'Indennizzo da Infortunio',
  },
  {
    id: 'capitale_caso_morte_infortunio',
    name: 'Capitale Caso Morte Infortunio',
  },
  {
    id: 'indennita_da_infortunio_grave',
    name: 'Indennità da Infortunio Grave',
  },
  {
    id: 'rsm_post_infortunio',
    name: 'RSM Post Infortunio',
  },
  {
    id: 'spese_mediche',
    name: 'Spese Mediche',
  },
  {
    id: 'bagaglio',
    name: 'Bagaglio',
  },
  {
    id: 'dipendente_pubblico_plus',
    name: 'Dipendente Pubblico Plus',
  },
  {
    id: 'pregressa_attivita_dipendente_privato',
    name: 'Pregressa attività da Dipendente Privato',
  },
  {
    id: 'ruolo_apicale_perdite_patrimoniali',
    name: 'Ruolo apicale – Perdite Patrimoniali',
  },
  {
    id: 'altre_perdite_patrimoniali',
    name: 'Altre Perdite Patrimoniali',
  },
  {
    id: 'attivita_accessorie_rc',
    name: 'Attività accessorie – Responsabilità Civile',
  },
  {
    id: 'attivita_scuola_specializzazione',
    name: 'Attività compatibili con la Scuola di Specializzazione',
  },
  {
    id: 'ultrattivita_estensione_volontaria',
    name: 'Ultrattività - Estensione volontaria in caso di prosecuzione dell’Attività',
  },
  {
    id: 'commercial_land',
    name: 'TERRENO',
  },
  {
    id: 'contenuto_systems_machines',
    name: 'CONTENUTO "IMPIANTI E MACCHINARI"',
  },
  {
    id: 'contenuto_industrial_commercial_machines',
    name: 'CONTENUTO "ATTREZZATURE INDUSTRIALI E COMMERCIALI"',
  },
];

export const primaQuoteTypes = [
  { id: 'kasko', name: 'Kasko completa' },
  { id: 'collisione', name: 'Kasko collisione' },
  { id: 'eventi_sociopolitici', name: 'Atti vandalici' },
  { id: 'eventi_naturali', name: 'Eventi naturali' },
  { id: 'bonus_protetto', name: 'Bonus protetto' },
  { id: 'furto_incendio', name: 'Furto e incendio' },
  {
    id: 'tutela_legale',
    name: 'Tutela Legale',
  },
  {
    id: 'assistenza_stradale',
    name: 'Assistenza Stradale',
  },
  {
    id: 'infortuni_conducente',
    name: 'Infortuni Conducente',
  },
  {
    id: 'cristalli',
    name: 'Cristalli',
  },
  {
    id: 'protezione_rivalse',
    name: 'Protezione Rivalse',
  },
  {
    id: 'collisione_veicoli_non_assicurati',
    name: 'Collisione con veicoli non assicurati',
  },
  {
    id: 'collisione_animali_selvatici',
    name: 'Collisione con animali selvatici',
  },
];

// Maps a `quotations`/quoteTypes id to the matching Prima guarantee slug
// (quotation_data_prima_guarantees[].slug), where one exists. Used to merge
// company_id 1001 (Nobis) quotes alongside/into Prima's own guarantee flow.
export const primaMergeQuoteTypes = [
  { id: 'infortuni_conducente', primaSlug: 'infortuni_conducente' }, // ? OK
  { id: 'tutela_legale', primaSlug: 'tutela_legale' }, // ? OK
  { id: 'assistenza_stradale', primaSlug: 'assistenza_stradale' }, // ? OK
  { id: 'collisione', primaSlug: 'collisione' }, // ? OK
  { id: 'cristalli', primaSlug: 'cristalli' }, // ? OK
  { id: 'eventi_naturali', primaSlug: 'eventi_naturali' },
  { id: 'eventi_socio_politici', primaSlug: 'eventi_sociopolitici' }, // ? OK
  { id: 'rivalsa', primaSlug: 'protezione_rivalse' },
  { id: 'ricordo_terzi_da_incendio', primaSlug: null },
  { id: 'furto_incendio', primaSlug: 'furto_incendio' }, // ? OK
  { id: 'kasko', primaSlug: 'kasko' }, // ? OK
];

export const reasonForReplacement = [
  { id: 'distruzione_o_demolizione_del_veicolo', name: 'Distruzione o demolizione del veicolo' },
  { id: 'cessazione_definitiva_della_circolazione_deicolo', name: 'Cessazione definitiva della circolazione del veicolo' },
  { id: 'esportazione_definitiva_del_veicolo', name: 'Esportazione definitiva del veicolo' },
  { id: 'alienazione_o_deposito_in_conto_vendita', name: 'Alienazione o deposito in conto vendita' },
  { id: 'furto_totale_dei_veicolo', name: 'Furto totale dei veicolo' },
];

export const getReasonForReplacement = (id) => {
  const reason = reasonForReplacement.find((item) => item.id === id);
  return reason ? reason.name : '';
};

export const getFiscalCode = (birthDate, userData, municipalities, states) => {
  const d = birthDate.split('-');
  const fData = {
    name: userData.name,
    surname: userData.surname,
    gender: userData.gender,
    day: d[2],
    month: d[1],
    year: d[0],
  };
  if (userData.born_abroad) {
    fData.birthplace = states.filter(
      (s) => s.state_code === userData.country_of_birth_code,
    )[0].name;
    fData.birthplaceProvincia = 'EE';
  } else {
    fData.birthplace = municipalities.filter(
      (municipality) => municipality.cadastral_code === userData.commune_of_birth_code,
    )[0].name;
    fData.birthplaceProvincia = userData.province_of_birth_code;
  }
  return generateFiscalCode(fData);
};

export const violationsResponsability = [
  {
    id: 'fullThings',
    name: "Con responsabilita' principale danni a: COSE",
  },
  {
    id: 'fullPersons',
    name: "Con responsabilita' principale danni a: PERSONE",
  },
  {
    id: 'fullMixed',
    name: "Con responsabilita' principale danni a: MISTI (cose + persone)",
  },
  {
    id: 'partialThings',
    name: "Con responsabilita' paritaria danni a: COSE",
  },
  {
    id: 'partialPersons',
    name: "Con responsabilita' paritaria danni a: PERSONE",
  },
  {
    id: 'partialMixed',
    name: "Con responsabilita' paritaria danni a: MISTI (cose + persone)",
  },
];

export const lastTenYears = (() => {
  const y = [];
  const maxYear = new Date().getFullYear();
  const minYear = maxYear - 11;
  for (let i = maxYear; i > minYear; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y.sort((a, b) => parseInt(a.id) - parseInt(b.id));
})();

export const sinceFirstInsuranceYears = (insuranceYear) => {
  const y = [];
  const maxYear = new Date().getFullYear();
  const selectedMinYear = (maxYear - parseInt(insuranceYear)) + 1;

  const minYear = maxYear - selectedMinYear;
  for (let i = maxYear; i > minYear; i--) {
    y.push({ id: i, name: i, value: i });
  }
  return y;
};

export const purchase_statues = [
  {
    id: 1,
    name: 'Attesa Documenti',
  },
  {
    id: 2,
    name: 'Problemi Con i Documenti',
  },
  {
    id: 3,
    name: 'Attesa Firma Documenti',
  },
  {
    id: 4,
    name: 'Attesa Pagamento',
  },
  {
    id: 5,
    name: 'Attesa Smarcatura',
  },
  {
    id: 6,
    name: 'In Attesa Emissione',
  },
  {
    id: 7,
    name: 'Polizza Emessa',
  },
  {
    id: 8,
    name: 'Inviato in compagnia',
  },
  {
    id: 9,
    name: 'KO',
  },
];
export const quotations_filter_statues = [
  {
    id: 'all',
    name: 'Tutti',
  },
  {
    id: 1,
    name: 'Attesa Documenti',
  },
  {
    id: 2,
    name: 'Problemi Con i Documenti',
  },
  {
    id: 3,
    name: 'Attesa Firma Documenti',
  },
  {
    id: 4,
    name: 'Attesa Pagamento',
  },
  {
    id: 5,
    name: 'Attesa Smarcatura',
  },
  {
    id: 6,
    name: 'In Attesa Emissione',
  },
  {
    id: 7,
    name: 'Polizza Emessa',
  },
  {
    id: 8,
    name: 'Inviato in compagnia',
  },
  {
    id: 9,
    name: 'KO',
  },

];

export const is_renewal = [
  {
    id: 'all',
    name: 'Tutti',
  },
  {
    id: 1,
    name: 'Si',
  },
  {
    id: 2,
    name: 'No',
  },
];

export const gendersCommertial = [
  {
    id: 'Male',
    name: 'Male',
  },
  {
    id: 'Female',
    name: 'Female',
  },
  {
    id: 'Unknown',
    name: 'Unknown',
  },
];

export const commercialChartKeys = [
  {
    id: 'incendio',
    name: 'Incendio',
  },
  {
    id: 'furto_e_rapina',
    name: 'Furto e Rapina',
  },
  {
    id: 'rct',
    name: 'RCT',
  },
  {
    id: 'rcto',
    name: 'RCTO',
  },
  {
    id: 'rc_prodotti',
    name: 'RC Prodotti',
  },
  {
    id: 'danni_indiretti',
    name: 'Danni Indiretti',
  },
  {
    id: 'merci',
    name: 'Merci',
  },
  {
    id: 'tutela_legale',
    name: 'Tutela Legale',
  },
  {
    id: 'cyber_risk',
    name: 'Cyber Risk',
  },
  {
    id: 'do',
    name: 'D&O',
  },
  {
    id: 'idrologico',
    name: 'Idrologico',
  },
  {
    id: 'eventi_naturali',
    name: 'Eventi Naturali',
  },
  {
    id: 'rischio_sismico',
    name: 'Rischio Sismico',
  },
  {
    id: 'danni_macchinari',
    name: 'Danni Macchinari',
  },
  {
    id: 'fenomeno_elettrico',
    name: 'Fenomeno Elettrico',
  },
  {
    id: 'key_man',
    name: 'Key Man',
  },
  {
    id: 'trasporti',
    name: 'Trasporti',
  },
  {
    id: 'rischio_ambiente',
    name: 'Rischio Ambiente',
  },
  {
    id: 'credito',
    name: 'Credito',
  },
];

export const ownerTypes = [
  {
    id: '1',
    name: 'Si, proprietà principale',
  },
  {
    id: '2',
    name: 'Si, proprietà secondaria',
  },
  {
    id: '3',
    name: 'Si, Locato a terzi',
  },
  {
    id: '4',
    name: 'No, sono in affitto',
  },
];

export const houseTypes = [
  {
    id: '1',
    name: 'Villa',
  },
  {
    id: '2',
    name: 'Appartamento',
  },
];

export const housing_types = [
  {
    id: '117',
    name: 'Villa indipendente (intero corpo)',
  },
  {
    id: '117A',
    name: 'Villa indipendente (porzione)',
  },
  {
    id: '118',
    name: 'Villa a schiera',
  },
];

export const apartament_types = [
  {
    id: '111',
    name: 'Appartamento P.T',
  },
  {
    id: '112',
    name: 'Appartamento 1°P',
  },
  {
    id: '113',
    name: 'Appartamento Piano Rialzato',
  },
  {
    id: '114',
    name: 'Appartamento Piano Ammezzato',
  },
  {
    id: '115',
    name: 'Appartamento Piano Intermedio',
  },
  {
    id: '116',
    name: 'Appartamento Ultimo Piano',
  },
];

export const residential_use_types = [
  {
    id: '141',
    name: 'Dimora abituale (di proprieta)',
  },
  {
    id: '142',
    name: 'Dimora saltuaria (di proprieta)',
  },
  {
    id: '143',
    name: 'Concessa in uso a terzi (di proprieta)',
  },
  // {
  //   id: '144',
  //   name: 'Vuota e/o inoccupata (di proprieta)',
  // },
  {
    id: '145',
    name: 'Dimora abituale (in locazione o con diritto di abitazione)',
  },
  {
    id: '146',
    name: 'Dimora Saltuaria (in locazione o con diritto di abitazione)',
  },
];

export const construction_feature_types = [
  {
    id: '161',
    name: 'Edifici ad incombustibilità totale o parziale',
  },
  {
    id: '162',
    name: 'Edifici in bioedilizia',
  },
];

export const construction_year = [
  {
    id: 'fino_al_1960',
    name: 'Fino al 1960',
  },
  {
    id: 'dal_1961_al_2004',
    name: 'Dal 1961 al 2004',
  },
  {
    id: 'dal_2005',
    name: 'Dal 2005',
  },
];

export const residential_use = [
  {
    id: '141',
    name: 'Dimora abituale (di proprieta)',
  },
  {
    id: '142',
    name: 'Dimora saltuaria (di proprieta)',
  },
  {
    id: '143',
    name: 'Concessa in uso a terzi (di proprieta)',
  },
  {
    id: '144',
    name: 'Vuota e/o inoccupata (di proprieta)',
  },
  {
    id: '145',
    name: 'Dimora abituale (in locazione o con diritto di abitazione)',
  },
  {
    id: '146',
    name: 'Dimora Saltuaria (in locazione o con diritto di abitazione)',
  },
];

export const workType = [
  {
    id: 'attivita_manuali',
    name: 'Attività Manuali',
  },
  {
    id: 'attivita_non_manuali',
    name: 'Attività non Manuali',
  },
];

export const year_of_construction_options = [
  {
    id: 'finno_al_1972',
    name: 'Fino al 1972',
  },
  {
    id: 'dal_1972_al_2009',
    name: 'Dal 1982 al 2009',
  },
  {
    id: 'oltre_il_2009',
    name: 'Oltre il 2009',
  },
];

export const number_of_floors_options = [
  {
    id: 'piano_terra',
    name: 'Piano Terra',
  },
  {
    id: '1',
    name: '1',
  },
  {
    id: '2',
    name: '2',
  },
  {
    id: 'superiore_a_2',
    name: 'Superiore a 2',
  },
];

export const branch_type = [
  {
    id: 'operative',
    name: 'Operative',
  },
  {
    id: 'office',
    name: 'Office',
  },
];

export const type_of_construction_options = [
  {
    id: 'muratura_o_ca_in_appoggio',
    name: 'Muratura o CA in appoggio',
  },
  {
    id: 'ca_legato',
    name: 'CA legato',
  },
  {
    id: 'legno_lamellare',
    name: 'Legno lamellare',
  },
  {
    id: 'acciaio',
    name: 'Acciaio',
  },
];

export const fabricated_options = [
  {
    id: 'di_proprieta',
    name: 'Di proprieta',
  },
  {
    id: 'in_locazione',
    name: 'In locazione',
  },
];

export const value_of_electronic_equipment_options = [
  {
    id: '10.000',
    name: '10.000',
  },
  {
    id: '15.000',
    name: '15.000',
  },
  {
    id: '20.000',
    name: '20.000',
  },
  {
    id: '25.000',
    name: '25.000',
  },
  {
    id: '50.000',
    name: '50.000',
  },
];

export const getQuotationTypeName = (id, quoteTypes) => {
  const quotationType = quoteTypes.find((item) => item.id === id);
  return quotationType ? quotationType.name : '';
};

export const getExtraCommercialQuoteTypeName = (id) => {
  const quotationType = commercialExtraQuoteTypes.find((item) => item.id === id);
  return quotationType ? quotationType.name : '';
};

export const urls = {
  auto: '/quotes/',
  autocarro: '/quotes/',
  moto: '/quotes/moto/',
  profession: '/quotes/profession/',
  'rc-professionale': '/quotes/profession/',
  metlife: '/quotes/metlife/',
  infortuni: '/quotes/infortuni/',
  travel: '/quotes/travel/',
  tutela_legale: '/quotes/tutela-legale/',
  commercial: '/quotes/commercial/',
  casa: '/quotes/casa/',
  salute: '/quotes/salute/',
  ancillari_auto: '/quotes/ancillari-auto/',
  sanitaria_per_stranieri: '/quotes/sanitaria-stranieri/',
  rc_professionale_sanita: '/quotes/rc-professionale-sanita/',
  public_employment: '/quotes/pubblico-impiego/',
  malattia: '/quotes/malattia/',
  infortunio: '/quotes/infortunio/',
  condominio: '/quotes/condominio/',
  rc_famiglia: '/quotes/rc-famiglia/',
  monopattini_elettrici: '/quotes/monopattini-elettrici/',
  surety_bonds: '/quotes/surety-bonds/',
};

export const purchaseUrls = {
  auto: '/quotes/auto/purchase/',
  autocarro: '/quotes/autocarro/purchase/',
  moto: '/quotes/moto/purchase/',
  profession: '/quotes/profession/purchase/',
  'rc-professionale': '/quotes/profession/purchase/',
  metlife: '/quotes/metlife/purchase/',
  infortuni: '/quotes/infortuni/purchase/',
  travel: '/quotes/travel/purchase/',
  tutela_legale: '/quotes/tutela-legale/purchase/',
  commercial: '/quotes/commercial/purchase/',
  casa: '/quotes/casa/purchase/',
  salute: '/quotes/salute/purchase/',
  ancillari_auto: '/quotes/ancillari-auto/purchase/',
  sanitaria_per_stranieri: '/quotes/sanitaria-stranieri/purchase/',
  rc_professionale_sanita: '/quotes/rc-professionale-sanita/purchase/',
  public_employment: '/quotes/pubblico-impiego/purchase/',
  malattia: '/quotes/malattia/purchase/',
  infortunio: '/quotes/infortunio/purchase/',
  condominio: '/quotes/condominio/purchase/',
  rc_famiglia: '/quotes/rc-famiglia/purchase/',
  monopattini_elettrici: '/quotes/monopattini-elettrici/purchase/',
  // Fideiussioni e Cauzioni has no purchase flow — it produces no quotations to buy. It maps
  // to its result page so a request in any status still opens somewhere real: a missing key
  // here builds the link "/undefined<token>", and NotFound redirects to the dashboard, so the
  // broker just sees the row do nothing.
  surety_bonds: '/quotes/surety-bonds/',
  offline_quote: '/quotes/offline/purchase/',
};

export const getQuotationStatus = (status) => {
  const statusData = quotations_filter_statues.find((item) => item.id == status);
  return statusData ? statusData.name : '';
};

export const stringToPrice = (price) => parseFloat(price).toLocaleString('it-IT', {
  style: 'currency',
  currency: 'EUR',
});

export const commercial_company_static_labels = {
  balance_sheet_total_assets: 'Bilancio Totale Attività',
  balance_sheet_total_current_assets: 'Bilancio Totale Attività Correnti',
  balance_sheet_total_liabilities: 'Bilancio Totale Passività',
  balance_sheet_total_shareholders_equity:
    'Bilancio Totale Capitale Proprio',
  balance_sheet_bank_liabilities: 'Bilancio Passività Bancarie',
  balance_sheet_called_up_share_capital:
    'Bilancio Capitale Sociale',
  balance_sheet_cash: 'Liquidità di Bilancio',
  balance_sheet_group_payables: 'Bilancio Debiti del Gruppo',
  balance_sheet_group_payables_due_after_1_year:
    'Bilancio Debiti del Gruppo Scadenti Dopo 1 Anno',
  balance_sheet_group_receivables: 'Bilancio Crediti del Gruppo',
  balance_sheet_receivables_due_after_1_year:
    'Bilancio Crediti del Gruppo Scadenti Dopo 1 Anno',
  balance_sheet_loans_to_group: 'Bilancio Prestiti al Gruppo',
  balance_sheet_total_current_liabilities:
    'Bilancio Totale Passività Correnti',
  balance_sheet_miscellaneous_fixed_assets:
    'Bilancio Altri Attivi Fissi',
  balance_sheet_miscellaneous_liabilities:
    'Bilancio Altre Passività',
  balance_sheet_miscellaneous_liabilities_due_after_1_year:
    'Bilancio Altre Passività Scadenti Dopo 1 Anno',
  balance_sheet_miscellaneous_receivables:
    'Bilancio Altri Crediti',
  balance_sheet_other_current_assets: 'Bilancio Altri Attivi Correnti',
  balance_sheet_other_intangible_assets:
    'Bilancio Altri Attivi Immateriali',
  balance_sheet_other_inventories: 'Bilancio Altri Inventari',
  balance_sheet_other_loans_or_finance:
    'Bilancio Altri Prestiti o Finanziamenti',
  balance_sheet_other_loans_or_finance_due_after_1_year:
    'Bilancio Altri Prestiti/Finanziamenti Scadenti Dopo 1 Anno',
  balance_sheet_other_reserves: 'Bilancio Altre Riserve',
  balance_sheet_other_tangible_assets: 'Bilancio Altri Attivi Tangibili',
  balance_sheet_revenue_reserves: 'Bilancio Riserve di Reddito',
  balance_sheet_total_fixed_assets: 'Bilancio Totale Attivi Fissi',
  balance_sheet_total_intangible_assets:
    'Bilancio Totale Attivi Immateriali',
  balance_sheet_total_long_term_liabilities:
    'Bilancio Totale Passività a Lungo Periodo',
  balance_sheet_total_other_fixed_assets:
    'Bilancio Totale Altri Attivi Fissi',
  balance_sheet_total_receivables: 'Bilancio Totale Crediti',
  balance_sheet_total_tangible_assets: 'Bilancio Totale Attivi Tangibili',
  balance_sheet_trade_payables: 'Bilancio Debiti Commerciali',
  balance_sheet_trade_receivables: 'Bilancio Crediti Commerciali',
  balance_sheet_work_in_progress: 'Bilancio Lavori in Corso',
  profit_loss_revenue: 'Profitti e Perdite Ricavi',
  profit_loss_operating_costs: 'Profitti e Perdite Costi Operativi',
  profit_loss_operating_profit: 'Profitti e Perdite Utile Operativo',
  profit_loss_financial_expenses: 'Profitti e Perdite Spese Finanziarie',
  profit_loss_wages_salaries: 'Profitti e Perdite Stipendi e Salari',
  profit_loss_depreciation: 'Profitti e Perdite Ammortamento(Attivi Tangibili)',
  profit_loss_amortisation: 'Profitti e Perdite Ammortamento(Attivi Immateriali)',
  profit_loss_profit_before_tax: 'Profitti e Perdite Prima delle Imposte',
  profit_loss_financial_income: 'Profitti e Perdite Reddito Finanziario',
  profit_loss_profit_other_appropriations:
    'Profitti e Perdite Altri Accantonamenti',
  profit_loss_tax: 'Profitti e Perdite Imposta',
  profit_loss_profit_after_tax: 'Profitti e Perdite Dopo le Imposte',
  profit_loss_profit_retained_profit: 'Profitti e Perdite Utile Retenuto',
  ratios_current_ratio: 'Rapporti Indice di Liquidità Corrente',
  ratios_liquidity_ratio_or_acid_test: 'Rapporti Indice di Liquidità or Test Acido',
  ratios_equity_in_percentage: 'Rapporti Equità in Percentuale',
  ratios_current_debt_ratio: 'Rapporti Indice di Indebitamento Corrente',
  ratios_gearing: 'Rapporti Indebitamento Finanziario',
  ratios_pre_tax_profit_margin: 'Rapporti Margine di Profitto Prima delle Imposte',
  ratios_return_on_capital_employed: 'Rapporti Ritorno sul Capitale Impiegato',
  ratios_return_on_net_assets_employed:
    'Rapporti Rendimento sugli Attivi Netti Utilizzati',
  ratios_debtor_days: 'Rapporti Giorni Debitori',
  ratios_creditor_days: 'Rapporti Giorni del Creditore',
  ratios_return_on_total_assets_employed:
    'Rapporti Rendimento del Totale delle Attività Impiegate',
  ratios_total_debt_ratio: 'Rapporti Debito totale',
  ratios_sales_or_net_working_capital: 'Rapporti Vendite o Capitale Circolante Netto',
  other_financials_net_worth: 'Altri Dati Finanziari - Patrimonio Netto',
  other_financials_working_capital: 'Altri Dati Finanziari - Capitale Circolante',
};

export const commercial_company_tabs = [
  'Azienda Commerciale',
  'Commenti Aziendali Commerciali',
  'Soci',
  'Direttori della Società Commerciale',
  'Struttura del Gruppo Estesa',
  'Bilanci Finanziari',
  'Filiali Aziendali',
  'Indicatori Aziendali',
  'Dati di Contatto',
];

export const commercial_catastrophe_tabs = [
  'Dichiarazioni del contraente',
  'Tipologia',
  'Altri dati',
  'Copertura',
  'Rapporto fra proprietario e contraente',
];

export const saluteInfo = [
  {
    quote_type: 'res_civile',
    limits: [
      'fino ad un massimo di 3 volte per anno assicurativo e per nucleo familiare le prestazioni al domicilio,',
      'fino ad un massimo di 12 volte per anno assicurativo e per nucleo familiare le prestazioni “Consulto medico” e “Consulto medico specialistico”',
      '1 volta per anno assicurativo e per Assicurato la prestazione “Medical coach”',
      'per un numero illimitato di volte, per anno assicurativo e per Assicurato, le prestazioni “Valutazione dei sintomi”, “Cartella salute”',
      '“Passaporto salute” e i servizi gratuiti “Accesso al network” e “Consegna farmaci al domicilio”, - 1 volta per anno assicurativo e per un solo familiare anziano le prestazioni “Care Manager” e “Assistenza domiciliare integrata (A.D.I.)',
      'Valutazione dei sintomi, accedendo alla tua area personale della piattaforma MyClinic, potrai in totale autonomia usufruire di un programma di autovalutazione che ti aiuterà a comprendere i tuoi sintomi e ti indicherà probabili cause e i possibili comportamenti da tenere',
      'Consulto medico in seguito all’autovalutazione dei sintomi e/o per approfondire il tuo stato di salute',
      'Consulto medico specialistico in seguito all’autovalutazione dei sintomi e/o per approfondire il tuo stato di salute. - Medical coach in seguito al consulto medico generico dalla tua area personale della piattaforma MyClinic potrai ricevere indicazioni per un programma personalizzato di check up definito sulla base della tua storia medica',
      'Cartella salute: accedendo alla tua area personale della piattaforma MyClinic potrai archiviare tutti i dati sulla tua salute pregressa e attuale, allegare esiti di esami e referti, inserire misurazioni dei tuoi parametri e tenere traccia dello storico, inserire i farmaci assunti. Potrai inoltre completare la tua cartella salute per condividere i tuoi dati durante il consulto medico',
      'Passaporto salute: se a seguito del consulto medico emerge la necessità di condividere i tuoi dati con un medico specialista in Italia e all’estero potrai creare, dalla tua cartella salute sulla piattaforma MyClinic, il tuo passaporto salute traducendo in modo automatico i tuoi dati nelle lingue disponibili',
      'Accesso al network: se devi effettuare delle visite mediche specialistiche, degli esami diagnostici, dei trattamenti fisioterapici, delle visite o dei trattamenti odontoiatrici, potrai usufruire del network convenzionato con la Struttura Organizzativa a tariffe agevolate. Questo è un servizio che ti viene fornito a titolo gratuito da Europ Assistance. - Consegna farmaci al domicilio: se hai bisogno della consegna di farmaci presso la tua abitazione, puoi richiedere al fornitore convenzionato con Europ Assistance la loro consegna a tariffe agevolate. Questo è un servizio che ti viene fornito a titolo gratuito da Europ Assistance. - Invio di un medico o di una autoambulanza in Italia presso la tua abitazione a seguito di Consulto medico',
      'Consegna farmaci al domicilio in seguito alla prestazione Invio di un medico in Italia presso la tua abitazione nel caso tu abbia bisogno di medicinali e non puoi andare a prenderli da solo',
      'Invio di un Infermiere al domicilio fino ad un massimo di 5 ore nel caso in cui a seguito di ricovero di almeno una notte',
    ],
    desc: 'Prestazioni solo in caso di Malattia e/o Infortunio. Puoi richiedere:',
    extra: 'Sono compresi in questa assicurazione anche: le conseguenze dei colpi di sole, di calore e di freddo e le folgorazioni - l’assideramento e il congelamento - gli avvelenamenti acuti da ingestione o assorbimento di sostanze dovuti a causa fortuita - l’asfissia non di origine morbosa - l’annegamento - le conseguenze delle infezioni dovute ad infortunio ad eccezione delle malattie - le conseguenze degli avvelenamenti causati da morsi di animali e punture di insetti, esclusa la malaria - gli infortuni subiti in stato di malore, di incoscienza o conseguenti a colpi di sonno - gli infortuni sofferti in conseguenza di tue imperizie, imprudenze e negligenze gravi - le lesioni corporali derivanti da tumulti popolari, atti di terrorismo, aggressioni o atti violenti aventi movente politico, sociale o sindacale, a condizione che tu non vi abbia preso parte attiva - a parziale deroga delle esclusioni, l’assicurazione si intende estesa agli infortuni derivanti da stato di guerra e di insurrezione per il periodo massimo di 14 giorni dall’inizio delle ostilità se non stai svolgendo il servizio militare e sei sorpreso dallo scoppio degli eventi bellici mentre ti trovi al di fuori del territorio della Repubblica Italiana, dello Stato della Città del Vaticano e della Repubblica di S. Marino - gli infortuni che ti derivano da alluvioni, inondazioni, movimenti tellurici ed eruzioni vulcaniche - gli infortuni derivanti dalla pratica non professionale di qualsiasi sport inclusi i seguenti sport pericolosi: pugilato; free climbing; guido slitta; bob; sci acrobatico; salto dal trampolino con sci o idroscì; lotta nelle sue varie forme; scalate di roccia o ghiaccio oltre il 3°grado della scala di Monaco, purché non effettuate isolatamente e fino al 3°grado comunque effettuate; speleologia; rugby; football americano; immersioni con autorespiratore; atletica pesante - le conseguenze di una eventuale embolia dovuta ad immersione con uso di autorespiratore - l’assicurazione è estesa agli infortuni che puoi subire durante i viaggi aerei turistici o di trasferimento, effettuati come passeggero, su velivoli o elicotteri da chiunque eserciti, esclusi quelli effettuati: da società/aziende di lavoro aereo, in occasione di voli diversi da trasporto pubblico di passeggeri, da aeroclub, su apparecchi per il volo da diporto o sportivo (quali ad esempio, deltaplani, ultraleggeri, parapendio)',
    numberList: [],
  },
  {
    quote_type: 'assistenza_malattia',
    limits: [
      'Assistenza in caso di ricovero: Trasferimento in centro ospedaliero, Rientro dal centro ospedaliero, Pernottamento di un accompagnatore',
      'Care Manager e Assistenza al domicilio post ricovero o post diagnosi malattia: consulenza socio assistenziale e invio di personale sanitario (medici, infermieri, fisioterapisti), personale non sanitario (colf, pet sitter e baby sitter), e socio- assistenziale (OSS), Supporto psicologico',
      'Assistenza in caso di malattia con obbligo di quarantena: Consegna farmaci al domicilio, Consegna Spesa al domicilo, Caring telefonico Assicurato convalescente',
    ],
    desc: '',
    extra: '',
    numberList: [],
    subText: 'Imposte al 10%',
  },
  {
    quote_type: 'adattamento_abitazione_malattia',
    limits: [],
    desc: 'Garanzia Adattamento all’abitazione. Una malattia grave diagnosticata per la prima volta dopo la data di decorrenza della polizza può averti causato una invalidità permanente. In questo caso Europ Assistance ti rimborsa le spese per adattare alla tua condizione la tua casa. Hai a disposizione fino ad un massimo complessivo di Euro 5.000,00 per sinistro e per anno assicurativo. Devi aver fatto richiesta per il riconoscimento degli incentivi di invalidità permanente come previsto dalla legge 13/89 e il rimborso andrà a garantire la parte delle spese da te sostenute che non ti sono state riconosciute',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'rsm_grave_malattia',
    limits: [],
    desc: 'Se ti viene diagnosticata per la prima volta una malattia grave dopo la data di decorrenza della polizza, Europ Assistance rimborserà le spese da te sostenute nel periodo in cui sei ricoverato in Istituto di Cura. Europ Assistance rimborsa spese sanitarie e i trattamenti fisioterapici e rieducativi Se sei ricoverato in strutture sanitarie convenzionate con Europ Assistance, Europ Assistance pagherà direttamente le spese fino al massimale di: - Euro 100.000,00 per Assicurato per sinistro e per anno assicurativo per le Gravi Malattie di Classe I; - Euro 250.000,00 per Assicurato per sinistro e per anno assicurativo per le Gravi Malattie di Classe II. Se è stata selezionata la Soluzione Famiglia i massimali sono per l’intero nucleo familiare i cui nominativi sono riportati sul Simplo di Polizza e per anno assicurativo. Se invece sei ricoverato in strutture sanitarie non convenzionate con Europ Assistance, Europ Assistance ti rimborserà fino al massimale sopra indicato l’importo che hai pagato applicando uno scoperto. Per sapere quali gravi malattie sono rimborsate, consulta l’Allegato I “Elenco Gravi malattie e loro classe di appartenenza” nelle Condizioni di Assicurazione. ',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'daria_da_convalescenza_malattia',
    limits: [],
    desc: 'Se hai avuto un ricovero in terapia intensiva superiore alle 72 ore per una malattia o per una febbre pandemica, Europ Assistance ti paga una Diaria di Euro 100,00 per ogni giorno di convalescenza prescritto dal medico curante al momento delle dimissioni, fino ad un massimo di 20 giorni per sinistro e per anno assicurativo.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'indennitaria_da_malattia',
    limits: [],
    desc: 'Europ Assistance ti paga l’indennizzo solo per una delle malattie rientranti tra quelle indicate nell’Allegato II “Elenco dettagliato delle malattie e loro classe di appartenenza” diagnosticata per la prima volta dopo la data di decorrenza della polizza. L’indennizzo che Europ Assistance ti paga, in base alla classe di appartenenza della malattia, va da un minimo di euro 4.800,00 in classe 1 ad un massimo di euro 15.000,00 in classe 4. La somma massima liquidabile in presenza di più malattie è di euro 30.000,00.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'assistenza_post_infortunio',
    limits: [],
    desc: 'Garanzia Assistenza post infortunio, solo in caso di infortunio rientrante tra quelli riportati nell’Allegato I° delle Condizioni di Assicurazione o per un infortunio grave. Puoi richiedere: le prestazioni 1 e 2 una volta per te e una volta per un solo familiare anziano, le prestazioni n. 3, 4, 5, 6, 7 e 8 solo per un infortunio rientrante tra quelli classificati di gravità V o per un infortunio grave, in ciascun anno di durata della polizza. Prestazioni:',
    extra: '',
    numberList: [
      'Care Manager. Ti fornisce una consulenza socio-assistenziale e valuta le diverse esigenze di cura.',
      'Assistenza Domiciliare Integrata (A.D.I.). La Struttura Organizzativa su valutazione del Care Manager, organizza e gestisce il ricovero per te e/o per un tuo familiare anziano in forma domiciliare mediante prestazioni di proprio personale medico e paramedico per un massimo di 30 giorni continuativi e non frazionabili. Inoltre organizza presso la vostra abitazione, avvalendosi di personale qualificato, prelievi del sangue, ecografie, elettrocardiogrammi non urgenti, pagamenti, acquisti, incombenze amministrative, collaborazione familiare, collaborazione di Operatori Socio Sanitari e/o socioassistenziali.',
      'Ricerca e prenotazione di centri riabilitativi, se devi sottoporti a riabilitazione fisioterapica.',
      'Trasferimento in una struttura riabilitativa in Italia. Se devi sottoporti a riabilitazione e per questo motivo devi essere ricoverato, la Struttura Organizzativa, con costi a carico di Europ Assistance, organizza il tuo trasporto in autoambulanza nella struttura riabilitativa.',
      'Rientro dalla struttura riabilitativa in Italia. La Struttura Organizzativa, con costi a carico di Europ Assistance, organizza il tuo rientro alla residenza dopo la degenza. ',
      'Ricerca negozi per articoli sanitari, presidi e protesi Se devi comprare articoli sanitari, presidi e protesi, puoi telefonare alla Struttura Organizzativa che ti indica il negozio più vicino alla tua abitazione.',
      'Supporto psicologico. Se hai bisogno di un aiuto psicologico, la Struttura Organizzativa ti organizza un incontro con uno psicologo. Europ Assistance tiene a proprio carico un massimo di 6 sedute con il limite complessivo di Euro 1.000,00 per sinistro e anno assicurativo. ',
      'Job coaching. Se l’infortunio che hai subito ha comportato lesioni fisiche tali per cui non puoi più svolgere la tua attività lavorativa, la Struttura Organizzativa mette a tua disposizione un coach esperto in consulenza in ambito lavorativo che organizzerà 6 sessioni individuali per supportarti nel percorso di ricollocazione professionale. Europ Assistance tiene a proprio carico i relativi costi',
    ],
  },
  {
    quote_type: 'adattamento_abitazione_veicolo_infortunio',
    limits: [],
    desc: 'Se uno degli infortuni tra quelli classificati di gravità V nella Tabella Indennizzi dell’Allegato I° delle Condizioni di Assicurazione o un infortunio grave ti ha causato una invalidità permanente, Europ Assistance ti rimborsa le spese per adattare alla tua condizione la tua casa fino ad un massimo complessivo di Euro 5.000,00 per sinistro e per anno assicurativo. ✓ Garanzia Adattamento automobile Se uno degli infortuni tra quelli classificati di gravità V nella Tabella Indennizzi dell’Allegato I° delle Condizioni di Assicurazione o un infortunio grave ti ha causato una invalidità permanente, Europ Assistance ti rimborsa le spese per adattare alla tua condizione la tua automobile, fino ad un massimo complessivo di Euro 5.000,00 per sinistro e per anno assicurativo.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'rsm_post_infortunio',
    limits: [],
    desc: 'Per visite ed esami e accertamenti diagnostici sostenuti nei 100 gg successivi all’infortunio incluso l’acquisto di farmaci.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'indennizzo_da_infortunio',
    limits: [],
    desc: 'Indennizzo da Infortunio (acquistabile in alternativa o insieme alla Garanzia Infortuni – Capitale caso morte e Indennità da Infortuno grave) Europ Assistance, in base alla soluzione che scegli, ti paga l’indennizzo solo per le conseguenze delle lesioni e nei limiti degli indennizzi riportati nella Tabella Indennizzi dell’Allegato I° della Condizioni di Assicurazione. Le soluzioni che puoi scegliere prevedono come somma massima liquidabile per più lesioni: Euro 50.000,00 per la versione Light, Euro 100.000 per la versione Premium ed Euro 200.000,00 per la versione Extra.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'capitale_caso_morte_infortunio',
    limits: [],
    desc: 'Un capitale da lasciare ai propri cari in caso di decesso post infortunio. Sono disponibili tre livelli di copertura: 75.000,00 €; 150.000,00 €; 250.000,00 €',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'indennita_da_infortunio_grave',
    limits: [],
    desc: 'Se a seguito di infortunio indennizzabile ai sensi delle Condizioni di Assicurazione, riporti postumi invalidanti pari o superiori al 50%, Europ Assistance ti paga la somma assicurata riportata sul Modulo di Polizza che potrai scegliere tra è Euro 75.000,00, Euro 150.000,00 ed Euro 250.000,00. ',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'rsm_post_ricovero_malattia',
    limits: [],
    desc: 'Rimborso delle spese mediche per visite specialistiche, esami diagnostici, per terapie oncologiche e farmaci sostenuti nei 100 giorni prima e nei 100 giorni dopo il ricovero',
    extra: '',
    numberList: [],
    subText: 'Imposte al 2,5%',
  },
  {
    quote_type: 'indennita_sostitutiva_malattia',
    limits: [],
    desc: 'In caso di ricovero presso il SSN viene corrisposto un indennizzo giornaliero per ogni girono di ricovero per una delle gravi malattie riportate nell’elenco del Set informativo. 100,00 € al giorno fino ad un massimo di 100 gg ',
    subText: 'Imposte al 2,5%',
    extra: '',
    numberList: [],
  },

];

export const casaInfo = [
  {
    quote_type: 'res_civile',
    limits: [
      'Invio di un fabbro, idraulico, elettricista per interventi in emergenza: garantisce il costo di uscita, della manodopera ed anche dei materiali necessari alla riparazione del danno;',
      "Interventi in emergenza per danni d'acqua;",
      'Invio di un termoidraulico, di un tapparellista, di un vetraio nelle 24h;',
      'Invio di un tecnico riparatore di elettrodomestici nelle 24h;',
      "Invio impresa di trasloco nel caso in cui, a seguito di incendio o allagamento - furto, l'abitazione fosse inagibile per un periodo minimo di 30 giorni;",
      "Invio impresa di pulizia nel caso in cui, a seguito di incendio o allagamento o furto, l'abitazione necessitasse di una pulizia straordinaria;",
      'Rientro anticipato all’abitazione danneggiata durante un viaggio',
      'Rientro da Pronto Soccorso con ambulanza, in caso di infortunio a seguito di scippo o rapina',
      'Assistenza per cure fisioterapiche con indirizzo riabilitativo presso l’Abitazione, in caso di infortunio a seguito di scippo o rapina',
      'Supporto psicologico a seguito di scippo o rapina',
      'Rifacimento documenti in caso di scippo o rapina',
      'Autovettura in sostituzione in caso di furto nel box di pertinenza dell’Abitazione',

    ],
    desc: '',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'incendio_fabbricato',
    limits: [
      'copre i danni causati da eventi sociopolitici, eventi atmosferici, sovraccarico neve, gelo;',
      'permette di ottenere il rimborso per spese sostenute a diverso titolo in seguito ad un sinistro quali ad esempio: demolizione, sgombero e pulitura delle macerie, spese di pernottamento in albergo;',
      "E' prevista copertura anche sul ricorso terzi e il rischio locativo.",
    ],
    desc: "Assicura contro diversi tipi di danni causati ai beni assicurati da incendio, fulmine, esplosione, scoppio, danni d'acqua e cristalli. Inoltre:",
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'incendio_contentuto',
    limits: [],
    desc: "Assicura contro diversi tipi di danni causati ai beni assicurati da incendio, fulmine, esplosione, scoppio, danni d'acqua e cristalli. La garanzia copre anche i danni alle merci in refrigerazione. La garanzia è valida per i beni contenuti nell'abitazione.",
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'danni_terzi_famiglia',
    limits: [],
    desc: "Assicura i danni involontariamente cagionati a terzi per morte, lesioni personali o danneggiamenti a cose, in conseguenza di un evento accidentale verificatosi in relazione ai fatti della vita privata, in relazione alla conduzione dell'abitazione indicata in polizza. Assicura inoltre i danni provocati o subiti da eventuali collaboratori domestici per fatti inerenti alle loro mansioni.",
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'danni_terzi_propietario',
    limits: [],
    desc: 'Assicura i danni involontariamente cagionati a terzi per morte, lesioni personali o danneggiamenti a cose, in conseguenza di un fatto accidentale verificatosi in relazione alla proprietà del fabbricato indicato in polizza.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'furto_casa',
    limits: [],
    desc: "Assicura il risarcimento del danno in caso di furto o rapina verificatisi nell'abitazione. La garanzia è prestata anche all'esterno dell'abitazione, assicurandomi contro il furto, lo scippo o la rapina di pellicce, preziosi, denaro e vestiario indossati.",
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'inagibilita',
    limits: [],
    desc: 'Prevede un indennizzo mensile per inagibilità causata da eventi atmosferici gravi come terremoto, alluvione o allagamento.',
    extra: '',
    numberList: [],
  },
  {
    quote_type: 'spese_legali_famiglia',
    limits: [],
    desc: 'Europ Assistance entro il massimale per sinistro, illimitato per anno, indicato nel Modulo di Polizza ti rimborsa le spese necessarie per la risoluzione amichevole delle controversie e per l’azione in giudizio in ogni sua fase. Europ Assistance assicura la tutela dei tuoi interessi nell’ambito della vita privata per:',
    extra: '',
    numberList: [
      'le richieste di risarcimento danni di natura extracontrattuale per fatti illeciti di terzi, anche in caso di costituzione di parte civile nell’ambito del procedimento penale a carico della controparte;',
      'la difesa in sede penale nei procedimenti per delitti colposi e per contravvenzioni, che è operante anche prima della formulazione ufficiale della notizia di reato;',
      'le controversie derivanti da contratti di locazione o dalla proprietà dell’Abitazione indicata sul Modulo di Polizza e da te occupata;',
      '. le controversie relative a diritti reali.',
    ],
  },
  {
    quote_type: 'fuori_uscita_di_acqua_gas',
    limits: [],
    desc: 'Fuoriuscita di acqua e gas: spese di ricerca e riparazione danni (Acquistabile solo in abbinamento all’Incendio e scoppio del Fabbricato). ',
    extra: '',
    numberList: [],
    subText: 'Se si verifica una fuoriuscita di acqua condotta a seguito di rottura accidentale degli impianti al servizio del Fabbricato, Europ Assistance, fino ad un massimo di Euro 1.500,00 per Sinistro e per anno assicurativo, ti indennizza le spese strettamente necessarie e connesse alla ricerca e alla riparazione/sostituzione delle condutture e dei relativi raccordi situate nei muri e nei pavimenti (con esclusione di quelle interrate), la cui rottura accidentale ha causato la fuoriuscita di acqua condotta. Se si verifica una dispersione di gas negli impianti di distribuzione di pertinenza della tua Abitazione che viene accertata dall’Azienda di distribuzione e che comporta da parte della stessa il blocco dell’erogazione del gas, Europ Assistance, fino ad un massimo di Euro 1.500,00 per Sinistro e per anno assicurativo, ti indennizza le spese strettamente necessarie e connesse alla riparazione/sostituzione delle tubazioni e dei relativi raccordi situate nei muri e nei pavimenti (con esclusione di quelle interrate), la cui rottura accidentale ha causato la fuoriuscita di gas.',
  },
  {
    quote_type: 'spese_legali_propietario_immobiliare',
    limits: [],
    desc: 'Europ Assistance entro il massimale per sinistro, illimitato per anno, indicato nel Modulo di Polizza ti rimborsa le spese necessarie per la risoluzione amichevole delle controversie e per l’azione in giudizio in ogni sua fase. Europ Assistance assicura la tutela dei tuoi interessi per fatti relativi all’Abitazione indicata nel Modulo di Polizza per: ',
    extra: '',
    numberList: [
      'l’azione legale e procedura arbitrale con compagnie di assicurazione diverse da Europ Assistance per contratti assicurativi che riguardano l’Abitazione assicurata;',
      'le richieste di risarcimento danni di natura extracontrattuale per fatti illeciti di terzi, ivi compreso l’inquilino dell’Abitazione assicurata, anche in caso di costituzione di parte civile nell’ambito del procedimento penale a carico della controparte;',
      'la difesa in sede penale nei procedimenti per delitti colposi e per contravvenzioni, che è operante anche prima della formulazione ufficiale della notizia di reato;',
      'le azioni relative alla riscossione di canoni di locazione o spese condominiali, che può essere prestata nei confronti dello stesso debitore per un unico Sinistro indipendentemente dalla durata della presente Polizza.',
    ],

  },

];

export const ancillariInfo = [
  {
    quote_type: 'collisione',
    company_id: '8',
    firstHeader: 'Dove vale la copertura?',
    desc: 'Si intendono i Paesi ove si e verificato il sinistro ed in cui le prestazioni vengono fornite. La polizza avra vigore nei seguenti Paesi: Italia, Repubblica di San Marino e Citta del Vaticano, Albania, Andorra, Austria, Belgio, Bosnia Erzegovina, Bulgaria, Cipro, Croazia, Danimarca continentale, Egitto, Estonia, Finlandia, Francia, Germania, Gibilterra, Grecia, Irlanda e Irlanda del Nord, Islanda, Israele, Lettonia, Libano, Liechtenstein, Lituania, Lussemburgo, Macedonia, Madera, Malta, Marocco, Moldavia, Principato di Monaco, Montenegro, Norvegia, Paesi Bassi, Polonia, Portogallo continentale, Regno Unito, Repubblica Ceca, Romania, Serbia, Siria, Slovacchia, Slovenia, Spagna continentale e isole del mediterraneo, Svezia, Svizzera, Tunisia, Turchia, Ucraina, Ungheria.',
    limits: [],
    secondHeader: '',
    secDesc: '',
    secondLimits: [
    ],
  },
  {
    quote_type: 'res_civile',
    company_id: '8',
    firstHeader: 'Dove vale la copertura?',
    desc: ' Si intendono i Paesi ove si e verificato il sinistro ed in cui le prestazioni vengono fornite. La polizza avra vigore nei seguenti Paesi: Italia, Repubblica di San Marino e Citta del Vaticano, Albania, Andorra, Austria, Belgio, Bosnia Erzegovina, Bulgaria, Cipro, Croazia, Danimarca continentale, Egitto, Estonia, Finlandia, Francia, Germania, Gibilterra, Grecia, Irlanda e Irlanda del Nord, Islanda, Israele, Lettonia, Libano, Liechtenstein, Lituania, Lussemburgo, Macedonia, Madera, Malta, Marocco, Moldavia, Principato di Monaco, Montenegro, Norvegia, Paesi Bassi, Polonia, Portogallo continentale, Regno Unito, Repubblica Ceca, Romania, Serbia, Siria, Slovacchia, Slovenia, Spagna continentale e isole del mediterraneo, Svezia, Svizzera, Tunisia, Turchia, Ucraina, Ungheria. ',
    secondHeader: 'Che obblighi ho? Quali obblighi ha l’impresa?',
    secDesc: "In caso di sinistro devi prendere immediatamente contatto con la Struttura Organizzativa, salvo il caso di oggettiva e comprovata impossibilita; in tal caso devi contattare la Struttura Organizzativa appena ne hai la possibilita e comunque sempre prima di prendere qualsiasi iniziativa personale. L'inadempimento di tali obblighi puo comportare la decadenza dal diritto alle prestazioni di assistenza, ai sensi dell’art. 1915 C.C.",
    limits: [],
    secondLimits: [],

  },
  {
    quote_type: 'tutela_legale',
    company_id: '8',
    firstHeader: 'Dove vale la copertura?',
    desc: ' Le garanzie prestate con la presente polizza sono operative per violazioni di legge e lesioni di diritti verificatesi in Europa. Per Europa si intende: Italia, Repubblica di San Marino, Citta del Vaticano, Albania, Algeria, Andorra, Austria, Belgio, Bosnia Erzegovina, Bulgaria, Croazia, Danimarca, Egitto, Estonia, Finlandia, Francia, Germania, Gibilterra, Grecia, Irlanda, Islanda, Liechtenstein, Lettonia, Libia, Lituania, Lussemburgo, Macedonia, Malta, Marocco, Moldavia, Principato di Monaco, Norvegia, Paesi Bassi, Polonia, Portogallo, Regno Unito, Repubblica Ceca, Romania, Serbia, Montenegro, Slovacchia, Slovenia, Spagna, Svezia, Svizzera, Tunisia, Turchia, Ucraina e Ungheria. Sono comunque esclusi dalla copertura di polizza gli oneri di assistenza stragiudiziale e giudiziale per violazioni di legge o lesioni di diritti verificatesi in paesi o in zone nelle quali siano in atto fatti bellici o rivoluzioni. ',
    secondHeader: '',
    secDesc: '',
    limits: [],
    secondLimits: [],

  },
  {
    quote_type: 'infortuni_conducente',
    company_id: '8',
    firstHeader: 'Dove vale la copertura?',
    desc: '  ',
    limits: [
      "L'assicurazione e valida in tutto il mondo",
      "Non sono coperti i sinistri che si sono verificati in quei Paesi che risultano soggetti ad embargo (totale o parziale) oppure a provvedimenti sanzionatori da parte delle Nazioni Unite e/o dell'Unione Europea. ",
    ],
    secondHeader: 'Che obblighi ho? Quali obblighi ha l’impresa?',
    secDesc: "In caso di sinistro tu o i tuoi aventi diritto dovete darne avviso scritto a Europ Assistance Italia S.p.A. – Via del Mulino, 4 – 20057 Assago (MI), indicando sulla busta - Ufficio Liquidazione Sinistri, entro tre giorni da quando ne hai avuto la possibilita, ai sensi dell'art. 1913 del Codice Civile. La denuncia del sinistro deve essere corredata da idonea certificazione medica e deve contenere l'indicazione del luogo, giorno ed ora dell'evento, nonchÈ una dettagliata descrizione delle sue modalita di accadimento. E’ necessario che tu invii ad Europ Assistance tutta la documentazione richiesta ai sensi di Polizza.  ",
    secondLimits: [],
  },
  {
    quote_type: 'cristalli',
    company_id: '8',
    firstHeader: 'Dove vale la copertura?',
    desc: '  ',
    limits: [
      'La di riparazione/sostituzione presso Centro Convenzionato e valida in: Austria, Belgio, Danimarca, Francia, Germania, Grecia, Irlanda, Italia, Lussemburgo, Norvegia, Paesi Bassi, Polonia, Portogallo, Regno Unito, Repubblica Ceca, Romania, Serbia, Montenegro, Slovenia, Spagna, Svezia, Svizzera, Turchia, Ungheria. ',
      'La prestazione a rimborso non prevede limitazioni rispetto all’estensione territoriale della polizza.',
    ],
    secondHeader: 'Che obblighi ho? Quali obblighi ha l’impresa?',
    secDesc: 'In caso di sinistro se intendi avvalerti di un Centro Convenzionato dovrai:',
    secondLimits: [
      'Interpellare telefonicamente la Struttura Organizzativa al numero verde 800.069.157 (Italia) o al numero nero 02.58.24.54.11 (Italia/Estero);',
      'comunicare il luogo in cui ti trovi;',
      'comunicare il numero di Polizza, il numero di targa e il tipo di Veicolo.',
    ],
    subText: 'Nel caso in cui tu desiderassi avvalerti di un Centro/Tecnico di tua fiducia, potrai contattare la Struttura Organizzativa e comunque, entro dieci giorni dalla data del Sinistro, dovrai darne avviso scritto tramite: E’ necessario che tu invii ad Europ Assistance tutta la documentazione richiesta ai sensi di Polizza. ',
  },
  {
    quote_type: 'res_civile',
    company_id: '16',
    firstHeader: '',
    desc: 'Le prestazioni offerte sono fornite fino ad un massimo di tre volte, per ciascun tipo e l’Assicurato per poterne beneficiare deve contattare preventivamente la Centrale Operativa. Le seguenti casistiche consentono di attivare la Centrale Operativa per richiedere l’erogazione delle prestazioni di assistenza:',
    limits: [
      'Guasto meccanico, inclusa la batteria scarica;',
      'Incidente stradale, Incendio, Atti vandalici, Eventi atmosferici (non calamità naturali);',
      'Furto, Tentato furto e Furto di parti del Veicolo; ',
      'Foratura degli pneumatici o rottura pneumatici;',
      'Esaurimento o errato rifornimento o congelamento o inquinamento del carburante;',
      'Esaurimento della carica della batteria della forza motrice elettrica (veicoli elettrici);',
      'Chiavi del Veicolo danneggiate o smarrite o rubate.',
    ],
    secondHeader: '',
    secDesc: '',
    secondLimits: [],
    subText: '',
  },
  {
    quote_type: 'tutela_legale',
    company_id: '16',
    firstHeader: '',
    desc: 'La garanzia vale nei confronti del Proprietario o Conducente autorizzato per i casi assicurativi riguardanti il Veicolo assicurato e la sua circolazione e precisamente per le seguenti prestazioni:',
    limits: [
      'L’esercizio di pretese al risarcimento danni a persone e/o cose subiti per fatti illeciti di terzi connessi alla circolazione stradale;',
      'Controversie contrattuali per presunte inadempienze proprie o della controparte relative al veicolo, con valore in lite superiore ad € 200,00;',
      'Difesa penale per delitti colposi o contravvenzioni connessi ad incidente stradale;',
      'Nel caso in cui vengano contestati al conducente reati di omicidio stradale o lesioni personali gravi o gravissime;',
      'Difesa penale per delitti dolosi;',
      'Opposizione avverso sanzioni amministrative di ritiro, sospensione, revoca della patente per incidente stradale;',
      'Controversie contrattuali con Compagnie di Assicurazioni Infortuni: fino al sotto limite di € 1.000;',
      'Opposizione avverso sanzioni amministrative in caso di furto del veicolo, furto della targa o clonazione della targa del veicolo: fino al sotto limite di € 1.000;',
      'Ricorso per violazioni al Codice della Strada: fino al sotto limite di € 5.000;',
      'Ricorso per errata variazione dei punti, in caso di Contraente persona fisica alla guida del veicolo assicurato',
    ],
    secondHeader: '',
    secDesc: '',
    secondLimits: [],
    subText: '',
  },
  {
    quote_type: 'infortuni_conducente',
    company_id: '16',
    firstHeader: '',
    desc: 'La garanzia opera anche per gli infortuni conseguenti a imperizia, imprudenza o negligenza anche grave del Conducente avvenuti durante la guida del Veicolo assicurato; ad atti compiuti per adempimento di soccorso; a caduta di rocce, pietre, alberi e simili; a caduta di valanghe o slavine; a malore o stato di incoscienza.',
    limits: [],
    secondHeader: '',
    secDesc: '',
    secondLimits: [],
    subText: '',
  },
  {
    quote_type: 'cristalli',
    company_id: '16',
    firstHeader: '',
    desc: 'La scelta della garanzia Cristalli comporta l’abbinamento di quest’ultima necessariamente ad almeno un’altra garanzia cd “principale” (in una qualsiasi formula e massimale). Il massimale scelto si intende quale limite per singolo sinistro, senza limiti di eventi nell’arco dell’annualità assicurativa. La garanzia cristalli viene estesa automaticamente anche atti vandalici, furto e tentato furto, purché vengano acquistate con il medesimo contratto per il medesimo veicolo, 4 Garanzie prescindendo dalla loro formula, oppure 3 Garanzie nella Formula Gold',
    limits: [],
    secondHeader: '',
    secDesc: '',
    secondLimits: [],
    subText: '',
  },

];

export const getProductNameById = (id) => {
  const product = productsList.find((prod) => prod.id === id);
  return product ? product.name : null;
};

export const getProductIcon = (productId) => {
  const iconMap = {
    1: faCar, // Auto
    2: faMotorcycle, // Moto
    3: faTruck, // Autocarro
    4: faBriefcase, // RC Professionale
    5: faNotesMedical, // Infortuni
    6: faCar, // InfoDrive
    8: faPlaneDeparture, // Viaggi (Travel)
    9: faGavel, // Tutela Legale
    10: faBuilding, // Commercio
    11: faHouseChimney, // Casa
    12: faPills, // Salute
    13: faCar, // Ancillari Auto
    14: faUserDoctor, // Sanitaria Stranieri
    15: faBriefcase, // RC Professionale Sanità
    1000: faUserTie, // Pubblico Impiego
    1001: faHeartPulse, // Malattia
    1002: faBandAid, // Infortunio
    1003: faPeopleRoof, // Condominio
    1004: faPeopleRoof, // RC Famiglia
  };

  return iconMap[productId] || faFileLines;
};

export const after_sale_purchase_statues = [
  {
    id: 1,
    name: 'Attesa Documenti',
  },
  {
    id: 2,
    name: 'Problemi Con i Documenti',
  },
  {
    id: 3,
    name: 'Attesa Pagamento',
  },
  {
    id: 4,
    name: 'Attesa Smarcatura',
  },
  {
    id: 6,
    name: 'Inviato in compagnia',
  },
  {
    id: 5,
    name: 'Completata',
  },
];

export const accident_statuses = [
  {
    id: 1,
    name: 'Inserito',
  },
  {
    id: 6,
    name: 'Inviato in compagnia',
  },
  {
    id: 2,
    name: 'Attesa perizia',
  },
  {
    id: 3,
    name: 'Attesa liquidazione',
  },
  {
    id: 4,
    name: 'Chiuso',
  },
];

export const maxBasedBrokerId = {
  46: ["8'000'000", "2'000'000"],
};
export const europe_or_world = [
  {
    id: 'europe',
    name: 'Europe',

  },
  {
    id: 'other_countries',
    name: 'Mondo',
  },

];

export const riskCategoryMediciDipendenti = [
  {
    id: 'dm_inclusa_ginecologia',
    name: 'Dirigente medico inclusa attività di Ginecologia e ostetricia',
  },
  {
    id: 'dm_esclusa_ginecologia',
    name: 'Dirigente medico esclusa attività di Ginecologia e ostetricia',
  },
  {
    id: 'specializzando',
    name: 'Specializzando',
  },
];

export const professionEmployeeTypes = [
  {
    id: 'dipendente_pubblico',
    name: 'Dipendente Pubblico',
  },
  {
    id: 'dipendente_privato',
    name: 'Dipendente Privato',
  },
  {
    id: 'libero_professionista',
    name: 'Libero Professionista',
  },
  {
    id: 'specializzando',
    name: 'Specializzando',
  },
];

export const retroattivitaMedici = [
  {
    id: '10_anni',
    name: '10 Anni',
  },
  {
    id: 'illimitata',
    name: 'Illimitata',
  },

];

export const attivitaMediche = [
  {
    id: 'chirurgical',
    name: 'Chirurgiche',
  },
  {
    id: 'non_chirurgical',
    name: 'Non Chirurgiche',
  },
];

export const retroattivitaMedicoProtetto = [
  {
    id: '10_anni',
    name: '10 Anni',
  },
  {
    id: 'illimitata',
    name: 'Illimitata',
  },
];

export const mediciLiberiProfessionistiRetroactivities = [
  {
    id: '0 anni',
    name: '0 Anni',
  },
  {
    id: '1 anni',
    name: '1 Anno',
  },
  {
    id: '2 anni',
    name: '2 Anni',
  },
  {
    id: '3 anni',
    name: '3 Anni',
  },
  {
    id: '4 anni',
    name: '4 Anni',
  },
  {
    id: '5 anni',
    name: '5 Anni',
  },
  {
    id: '10 anni',
    name: '10 Anni',
  },
  {
    id: 'ilimitata',
    name: 'Illimitata',
  },
];

export const mlpTypes = [
  {
    id: 'Visite',
    name: 'Visite',
  },
  {
    id: 'Invasiva',
    name: 'Invasiva',
  },
  {
    id: 'Chirurgica',
    name: 'Chirurgica',
  },
];

export const mlpMassimali = [
  {
    id: '1000000',
    name: '1.000.000 €',
  },
  {
    id: '2000000',
    name: '2.000.000 €',
  },
  {
    id: '3000000',
    name: '3.000.000 €',
  },
];

export const vehicle_plate_types = [
  {
    id: '0',
    name: 'Targa Nuova',
  },
  {
    id: '1',
    name: 'Targa Vecchia',
  },
  {
    id: '2',
    name: 'Altro',
  },

];

export const compensationPaymentMethod = [
  {
    id: 'bonifico',
    name: 'Bonifico',
  },
  {
    id: 'contanti',
    name: 'Contanti',
  },
];

export const tipologiaPatente = [
  {
    id: 'a',
    name: 'A',
  },
  {
    id: 'b',
    name: 'B',
  },
  {
    id: 'c',
    name: 'C',
  },
  {
    id: 'd',
    name: 'D',
  },
  {
    id: 'b_e',
    name: 'B+E',
  },
  {
    id: 'c_e',
    name: 'C+E',
  },
  {
    id: 'd_e',
    name: 'D+E',
  },
];

export const flagResponseSelect = [
  {
    id: '1',
    name: 'Sì',
  },
  {
    id: '0',
    name: 'No',
  },
];

export const tutelaFamiliareMassimale = [
  {
    id: 25000,
    name: '25.000€',
  },
  {
    id: 50000,
    name: '50.000€',
  },
];

export const rcFamigliaMassimale = [
  {
    id: 260000,
    name: '260.000,00€',
  },
  {
    id: 520000,
    name: '520.000,00€',
  },
  {
    id: 780000,
    name: '780.000,00€',
  },
];

export const monopattiniVersion = [
  {
    id: 'individuale',
    name: 'Individuale',
  },
  {
    id: 'familiare',
    name: 'Familiare',
  },
];

export const monopattiniPackage = [
  {
    id: 'oro',
    name: 'Oro',
  },
  {
    id: 'argento',
    name: 'Argento',
  },
  {
    id: 'platino',
    name: 'Platino',
  },
];

export const professionalRoles = [
  {
    id: 'dipendente',
    name: 'Dipendente',
  },
  {
    id: 'direttore_ceo',
    name: 'Direttore/CEO',
  },
  {
    id: 'manager',
    name: 'Manager',
  },
  {
    id: 'libero_professionista',
    name: 'Libero Professionista',
  },
];

export const nobisPaymentMethods = [
  { id: '01', name: 'Annuale' },
  { id: '02', name: 'Semestrale' },
  // { id: '03', name: 'Quadrimestrale' }, // disabled as for now
  // { id: '04', name: 'Trimestrale' }, // disabled as for now
];
export const commercialPaymentFrequency = [
  {
    id: 2,
    name: 'Annuale',
  },
  {
    id: 3,
    name: 'Poliennale',
  },
];

export const payment_frequency = [
  {
    id: '1',
    name: 'Annuale',
  },
  {
    id: '2',
    name: 'Semestrale',
  },

];

export const GenderEnum = {
  Male: 'M',
  Female: 'F',
  LegalPerson: 'G',
};

export const getDDFDocument = (rc_quotation, insuranceRequest) => {
  let DDF_document = rc_quotation?.initial_quotation?.insurance_request?.documents?.find((doc) => doc.document_type_id === 34);

  if (!DDF_document) {
    DDF_document = insuranceRequest?.documents?.find((doc) => doc.document_type_id === 34);
  }

  return DDF_document;
};

export const getQuestionarioMalattiaDocument = (rc_quotation, insuranceRequest) => {
  let DDF_document = rc_quotation?.initial_quotation?.insurance_request?.documents?.find((doc) => doc.document_type_id === 1005);

  if (!DDF_document) {
    DDF_document = insuranceRequest?.documents?.find((doc) => doc.document_type_id === 1005);
  }

  return DDF_document;
};
export const numberOfOrganizations = [
  {
    id: 1,
    name: '1',
  },
  {
    id: 2,
    name: '2',
  },
];

export const typeOfOrganizations = [
  {
    id: 'ministeri',
    name: 'Ministeri',
  },
  {
    id: 'organi_costituzionali',
    name: 'Organi Costituzionali',
  },
  {
    id: 'agenzie_fiscali',
    name: 'Agenzie Fiscali',
  },
  {
    id: 'magistratura',
    name: 'Magistratura',
  },

  {
    id: 'enti_gestione_parchi',
    name: 'Enti di Gestione Dei Parchi',
  },

  {
    id: 'autorita_portuali',
    name: 'Autorità Portuali',
  },
  {
    id: 'altre_tipologie_amministrazione_centrale_stato',
    name: 'Altre Tipologie di Amministrazione Centrale dello Stato',
  },
  {
    id: 'amministrazioni_regionali',
    name: 'Amministrazioni Regionali',
  },
  {
    id: 'amministrazioni_provinciali',
    name: 'Amministrazioni Provinciali',
  },
  {
    id: 'amministrazioni_comunali',
    name: 'Amministrazioni Comunali',
  },
  {
    id: 'enti_gestione_acque_tutela_territorio',
    name: 'Enti Gestioni Acque o Tutela Territorio',
  },
  {
    id: 'agcm',
    name: 'AGCM',
  },
  {
    id: 'agcom',
    name: 'AGCOM',
  },
  {
    id: 'agia',
    name: 'AGIA',
  },
  {
    id: 'anac',
    name: 'ANAC',
  },
  {
    id: 'arera',
    name: 'ARERA',
  },
  {
    id: 'art',
    name: 'ART',
  },
  {
    id: 'cgs',
    name: 'CGS',
  },
  {
    id: 'consob',
    name: 'CONSOB',
  },
  {
    id: 'covip',
    name: 'COVIP',
  },
  {
    id: 'ivass',
    name: 'IVASS',
  },
  {
    id: 'privacy',
    name: 'Privacy',
  },
  {
    id: 'altre_puthority',
    name: 'Altre Puthority',
  },
  {
    id: 'enti_sanitari',
    name: 'Enti Sanitari',
  },
  {
    id: 'enti_socio_assistenziali',
    name: 'Enti Socio Assistenziali',
  },
  {
    id: 'enti_agenzie_ambienti',
    name: 'Enti e Agenzie Ambienti',
  },
  {
    id: 'inps',
    name: 'INPS',
  },
  {
    id: 'inail',
    name: 'INAIL',
  },
  {
    id: 'federazioni_sportive',
    name: 'Federazioni Sportive',
  },
  {
    id: 'universita_politecnici',
    name: 'Università e Politecnici',
  },
  {
    id: 'comere_di_commercio',
    name: 'Comere di Commercio',
  },
  {
    id: 'fondazioni',
    name: 'Fondazioni',
  },
  {
    id: 'enti_struttura_associativa',
    name: 'Enti a Struttura Associativa',
  },
  {
    id: 'teatri',
    name: 'Teatri',
  },
  {
    id: 'altri_organismi_diritto_pubblico',
    name: 'Altri Organismi di Diritto Pubblico',
  },
];

export const fascia = [
  {
    id: 'organo_vertice_e_suo_vice',
    name: 'Organo di vertice e suo Vice (es. Sindaco Comune, Presidente, Amministratore Unico, Rettore, Comandante, Prefetto, Commissario Straordinario, Liquidatore, ecc)',
  },
  {
    id: 'dirigenti_tecnici',
    name: 'Dirigenti Tecnici',
  },
  {
    id: 'direttore_generale_regione',
    name: 'Direttore Generale di Regione',
  },
  {
    id: 'dirigente_legali_con_procura',
    name: 'Dirigenti legali con Procura',
  },
  {
    id: 'dirigente_generale_unico',
    name: 'Direttore Generale Unico',
  },
  {
    id: 'direttore_sanitario',
    name: 'Direttore Sanitario (incluso direttore di presidio)',
  },
  {
    id: 'alti_ufficiali',
    name: 'Alti Ufficiali (*Per Alti Ufficiali si intende da Colonnello in su)',
  },
  {
    id: 'parlamentari',
    name: 'Parlamentari',
  },
  {
    id: 'magistrati',
    name: 'Magistrati',
  },
  {
    id: 'capo_gabinetto',
    name: 'Capo Gabinetto',
  },
  {
    id: 'presidente_cda_membri_collegio_sindacale_revisori',
    name: 'Presidente/Membri CDA/Collegio sindacale/Revisori',
  },
  {
    id: 'alta_professionalita',
    name: 'Alta professionalità',
  },
  {
    id: 'direttore_amministrativo_finanziario',
    name: 'Direttore Amministrativo/Finanziario',
  },
  {
    id: 'membri_odv_consiglio_sorveglianza',
    name: 'Membri ODV / Consiglio di sorveglianza / Membro del collegio di gestione / Comitato di gestione',
  },
  {
    id: 'dipendente_tecnico_incluso_rup',
    name: 'Dipendente Tecnico incluso RUP',
  },
  {
    id: 'dirigenti_amministrativi',
    name: 'Dirigenti amministrativi',
  },
  {
    id: 'direttore_responsabile_dipartimento',
    name: 'Direttore/Responsabile di dipartimento/divisione/direzione',
  },
  {
    id: 'assessori',
    name: 'Assessori',
  },
  {
    id: 'ufficiali',
    name: 'Ufficiali',
  },
  {
    id: 'agenti_contabili_tesorieri',
    name: 'Agente Contabile/Tesoriere',
  },
  {
    id: 'consigliere_regionale',
    name: 'Consigliere Regionale',
  },
  {
    id: 'consigliere_provinciale_area_metropolitana',
    name: 'Consigliere Provinciale/Area Metropolitana',
  },
  {
    id: 'segretario_comunale_provinciale_generale',
    name: 'Segretario Comunale/Provinciale/Generale',
  },
  {
    id: 'direttore_universitario',
    name: 'Direttore Universitario (Generale e Amministrativo)',
  },
  {
    id: 'cda_istituzioni_scolastiche_culturali',
    name: 'CDA di Istituzioni scolastiche e culturali / fondazioni non economiche / casse e ordini professionali',
  },
  {
    id: 'componente_nucleo_valutazione_oiv',
    name: 'Componente Nucleo di Valutazione / OIV',
  },
  {
    id: 'membro_giunta_camera_commercio',
    name: 'Membro giunta Camera di Commercio',
  },
  {
    id: 'posizione_organizzativa_incluso_rup',
    name: 'Posizione Organizzativa incluso RUP',
  },
  {
    id: 'sotto_ufficiali',
    name: 'Sotto Ufficiali',
  },
  {
    id: 'polizia_locale_consigliere_comunale',
    name: 'Polizia Locale / Consigliere Comunale/Municipio/Circoscrizione',
  },
  {
    id: 'docenti',
    name: 'Docenti',
  },
  {
    id: 'consiglieri_federazioni_sportive',
    name: 'Consiglieri delle Federazioni Sportive',
  },
  {
    id: 'consiglieri_ordini_professionali',
    name: 'Consiglieri Ordini professionali',
  },
  {
    id: 'dipendente_ufficio_tecnico_senza_progettazione',
    name: 'Dipendente di ufficio tecnico senza progettazione',
  },
  {
    id: 'dipendenti_amministrativi',
    name: 'Dipendenti Amministrativi',
  },
  {
    id: 'assistenti_sociali',
    name: 'Assistenti Sociali',
  },
  {
    id: 'legale_senza_procura',
    name: 'Legale senza procura',
  },
];

export const communePopulation = [
  {
    id: 'fino_14999',
    name: 'Fino a 14,999',
  },
  {
    id: 'tra_15000_e_50000',
    name: 'Tra 15,000 e 50,000',
  },
  {
    id: 'oltre_50000',
    name: 'Oltre 50,000',
  },
];

export const componentiNucleoFamigliare = [
  {
    id: '1',
    name: '1',
  },
  {
    id: '2',
    name: '2',
  },
  {
    id: '3',
    name: '3',
  },
  {
    id: '4',
    name: '4',
  },
  {
    id: '5',
    name: '5',
  },
];

export const immobileAge = [
  {
    id: 'under_11',
    name: 'Meno di 11 Anni',
  },
  {
    id: 'between_11_and_25',
    name: 'Tra 11 e 25 Anni',
  },
  {
    id: 'more_than_25',
    name: 'Più di 25 Anni',
  },

];

export const getProductNameForUrl = (id) => {
  if (id === 1) return 'auto';
  if (id === 2) return 'moto';
  if (id === 3) return 'autocarro';
  if (id === 4) return 'profession';
  if (id === 5) return 'metlife';
  if (id === 6) return 'infodrive';
  if (id === 8) return 'travel';
  if (id === 9) return 'tutela-legale';
  if (id === 10) return 'commercial';
  if (id === 11) return 'casa';
  if (id === 12) return 'salute';
  if (id === 13) return 'ancillari-auto';
  if (id === 14) return 'sanitaria-stranieri';
  if (id === 15) return 'rc-professionale-sanita';
  if (id === 1000) return 'pubblico-impiego';
  if (id === 1001) return 'malattia';
  if (id === 1002) return 'infortunio';
  if (id === 1003) return 'condominio';
  if (id === 1004) return 'rc-famiglia';
  if (id === 1006) return 'monopattini-elettrici';

  return null;
};

export const safeCapitalizeWords = (str) => {
  try {
    if (typeof str !== 'string') return str; // leave as is if not a string
    return str
      .toLowerCase()
      .split(/\s+/) // splits on any whitespace
      .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ''))
      .join(' ');
  } catch (e) {
    return str; // fallback: return original string if anything fails
  }
};
